const English = {
  to: 'To',
  cc: 'CC',
  agenda: 'Agenda',
  invoiceAge:'Invoice Age',
  time: 'Time',
  responsibility: 'Responsibility',
  requiredfeatureDesc: 'New Feature Description is required!',
  requirednewFeature: 'New Feature is required!',
  requiredpaymentTerms: 'Payment Terms is required!',
  requiredvehicleType: 'Vehicle Type is required!',
  requireddescription: 'Description is required!',
  description: 'Description',
  emailBody: 'Body',
  invDescription: 'Description ',
  cDescription: 'Complaint',
  requiredmarketing: 'Marketing Commitment is required!',
  requiredcost: 'Cost is required!',
  requiredlocation: 'Location is required!',
  requiredsupplyNamePost: 'Supply Name is required!',
  requiredTagsNoPost: 'No. of Tags is required!',
  requiredslotsNoTwoWheeler: 'No. of Slots - Bike (2-Wheeler) is required!',
  requiredslotsNoFourWheeler: 'No. of Slots - Bike (4-Wheeler) is required!',
  requiredtotalContract: 'Total Contract Length is required!',
  requiredpaymentTermsDesc: 'Payment Terms Description is required!',
  requiredrevenueShare: 'Revenue Share is required!',
  requiredMGPerSlot: 'MG - Cost Per Slot is required!',
  requiredrevenueSlots: 'Revenue Share Slots is required!',
  requiredMGSlots: 'Number of MG Slots is required!',
  requiredtotalAmount: 'Total Amount (Excluding Taxes) is required!',
  requiredcompanyShare: 'Company Share is requied!',
  requiredclientShare: 'Client Share is required!',
  requiredyearlyInclin: 'Yearly Inclination is required!',
  requiredadvertisingCommercials: 'Advertising Commercials is required!',
  requiredvaletProduct: 'Valet Product Commercials is required!',
  requiredpaymentMode: 'Payment Mode is required!',
  requiredpaymentDueDays: 'Payment Due Days is required!',
  requiredsubAmt: 'Subscription Amount (Excluding Taxes) is required!',
  requiredinstallationAmount:
    'Installation Amount (Excluding Taxes) is required!',
  requiredslotsRevenue2Bike:
    'No. of Slots on revenue share - Bike (2-Wheeler) is required!',
  requiredslotsRevenue4Car:
    'No. of Slots on revenue share - Car (4-Wheeler) is required!',
  requiredmarketingSignageType:
    'Marketing/Signage requirement type is required!',
  requiredmarketingSignageCount:
    'Marketing/Signage requirement count is required!',
  requiredLockIn: 'Contract Lock-in Period is required!',
  requiredpo_woNumber: 'P.O/W.O/Contract Number is required!',
  requiredcategoryAlliances: 'Category of Alliances is required!',
  requiredaddress: 'Address is required!',
  requiredinternetAvailabilty: 'Internet Availabilty is required!',
  requiredcurrentSetup: 'Current Setup is required!',
  requiredselectMaterial: 'Material is required!',
  requiredselectCategory: 'Category is required!',
  requiredmaterialHardwareReq: 'Material/Hardware is required!',
  requiredmarketingReq: 'Marketing/signage requirement is required!',
  requiredanyOther: 'Any other rule is required!',
  requiredPaneltyLosing: 'Penalty on losing parking ticket is required!',
  requiredtwowheelers: 'Two wheelers allowed to park with cars is required!',
  requiredovernight: 'Overnight parking allowed is required!',
  requiredgstNumber: 'GST Number is required!',
  requiredgstDetails: 'GST Details is required!',
  requiredcontractType: 'Contract Type is required!',
  PaneltyLosing: 'Penalty on losing parking ticket',
  requiredCharacter: 'Only Characters are allowed!',
  requiredDecimal: 'Not allow more than 2 decimal place!',
  requiredslots2MgBike: 'No. of Slots on MG-Bike is required!',
  requiredslots2MgCar: 'No. of Slots on MG-Car is required!',
  requiredsecurityDeposit: 'Security Deposit is required!',
  requiredcostPerSlot: 'Cost Per Slot is required!',
  requiredTakeEtaxes: 'Take E Taxes is required!',
  requiredparkCommission: 'Park+Commission is required!',
  requiredcommercialType: 'Commercial Type is required!',
  requiredsiteType: 'Site Type is required!',
  requiredExpectedClosureDate: 'Expected Closure Date is required!',
  ExpectedClosureDate: 'Expected Closure Date',
  requirednextFollowUpDate: 'Next FollowUp Date is required!',
  requirednextSteps: 'Next Steps is required!',
  requiredaddPOCButton: 'Add POC is required!',
  requiredLastInteractionDate: 'Interaction Date is required!',
  requiredProgressiveRatePerHour: 'Progressive Rate Per Hour is required!',
  requiredParkingRate: 'Parking Rate is required!',
  requiredParkingHour: 'Parking Hour is required!',
  requiredFixedParkingRates: 'Fixed Parking Rates is required!',
  requiredOtherLocation: 'Other Location Present is required!',
  requiredParkingEquipmentRemark: 'Parking Equipment Remark is required!',
  requiredStackparking: 'Stack Parking is required!',
  requiredSlotSensor: 'Slot Sensor',
  requiredParkingEquipment: 'Parking Equipment Manufacture is required!',
  requiredParkingManagement: 'Parking Management Company in required!',
  requiredParkingCharges: 'Parking Charges Type is required!',
  requiredResturantinChain: 'No. of Restaurants in Chain is required!',
  requiredRestaurantsVicinity: 'Restaurants in Vicinity is required!',
  requiredCorporateOffices: 'Corporate offices in vicinity is required!',
  requiredLanesExit: 'No. of lanes (Exit) is required!',
  requiredLanesEntry: 'No. of lanes (Entry) is required!',
  requiredGateFeature: 'Gate Feature is required!',
  requiredTotalParking: 'Total no. of Parking Slot is required!',
  requiredValet: 'Valet is required!',
  uploadQuotation: 'Upload Quotation',
  requiredGeoState: 'Geographical State is required!',
  requiredGeoCity: 'Geographical City is required!',
  requiredPhonenumber: 'Phone number is required!',
  leadCorporate: 'Lead Corporate Details',
  numericError: 'Only Numeric value are allowed!',
  requiredQuantity: 'Quantity is required!',
  requiredDescription: 'Description is required!',
  requiredMaterial: 'Material is required!',
  requiredProduct: 'Product is required!',
  requiredgate: 'Gates are required!',
  requiredComplainType: 'Complain Type is required!',
  requiredComplainRaisedBy: 'Complain Raised By is required!',
  requiredRemark: 'Remark is required!',
  requiredSiteName: 'Site Name is required!',
  requiredDate: 'Date is required!',
  BacktoList: 'Back to list',
  zeroError: 'Should not be Zero!',
  requiredSummary: 'Summary is required!',
  requiredSubject: 'Subject is required!',
  requiredName: 'Name is required!',
  requiredType: 'Type is required!',
  requiredClosureDate: 'Expected Closure Date is required!',
  requiredNextFollow: 'Next FollowUp Date is required!',
  requiredPoc: 'Add POC is required!',
  requiredCurrentStatus: 'Current Status is requied!',
  requiredDealStatus: 'Deal Status is required!',
  requiredLastInterdate: 'Last Interaction Date in required!',
  requiredReserve: 'No. of Reserved Slots are required!',
  requiredFCFSslot: 'No. of FCFS Slots are required',
  requiredGate: 'No. of Gates are requied!',
  requiredSlot: 'No. of Slots are required!',
  requiredEVCharger: 'No. of EV Chargers are required!',
  requiredLatitude: 'Latitude is required!',
  requiredLongitude: 'Longitude is required!',
  requiredLeadCateg: 'Project Category is required!',
  requiredManagedBy: 'Managec By is required!',
  requiredSocietyType: 'Society Type is required!',
  requiredGateType: 'Gate Type is required!',
  requiredLocation: 'Location Type is required!',
  required : 'Required!',
  requiredAddress: 'Client Address is required!',
  requiredArea: 'Area/Sector is required!',
  requiredCity: 'City is required!',
  requiredZone: 'Zone is required!',
  requiredClientName: 'Client Name is required!',
  requiredBillingAddress: 'Billing Address is required!',
  requiredClientPoc: 'Client POC is required!',
  requiredLeadSource: 'Lead Source is required!',
  requiredInteractionType: 'Interaction Type is required!',
  requiredPocName: 'POC Name is required!',
  requiredPocDesig: 'POC Designation is required!',
  requiredPocType: 'POC Type is required!',
  requiredErrorMg: 'This field is required',
  alphaErrorMg: 'Only Alpha Numeric characters are allowed!',
  warning : 'Warning!',
  numericErrorMg: 'Only numbers are allowed',
  categoryDetails: 'Category Details',
  createB2BAlliances: 'Create Lead B2B Alliances',
  partnerCompanyName: 'Partner/Company Name',
  categoryAlliances: 'Category of Alliances',
  dashboard: 'Dashboard',
  dateType : 'Select Date Range',
  freshdeskTickets: 'L2 Support Tickets',
  createTickets: 'Create Ticket',
  createFdTickets: 'Create L2 Support Ticket',
  enterFdDetails: 'Enter Ticket Details',
  selectPriority: 'Select Priority',
  priority: 'Priority',
  category: 'Category',
  fdCreatedSuccess: 'Ticket created successfully!',
  goToFdListing: 'Go to Ticket Listing',
  freshdeskId: 'Fresh Desk Id',
  reportedBy: 'Reported By',
  reportedOn: 'Reported On',
  closedOn: 'Closed On',
  tat: 'TAT',
  categoryLead: 'Create Lead Apartment',
  clientAprtname: 'Site Name',
  businessName: 'Business Name',
  postCorporate: 'Post Sales Corporate',
  postApartment: 'Post Sales Apartment',
  postSupply: 'Post Sales Supply',
  createLead: 'Create Lead',
  corporate: 'Corporate',
  apartments: 'Apartments',
  supply: 'Supply',
  B2BAlliances: 'B2B Alliances',
  fusion: 'Fusion',
  submitDtl: 'Submit',
  bulkUpload: 'Bulk Upload',
  uploadFlats : 'Upload Flats',
  DownloadFlatFile: 'Download Flat File',
  loginToAccount: 'Login to your account',
  // emailIdNo: 'Email ID or Phone Number',
  emailIdNo: 'Email ID',
  emailAddress: 'Email Address',
  emilSendTo: 'Email Address (Invoices to be send on this email id)',
  POCName: 'POC Name',
  fmcName: 'FMC Name',
  POCDesignation: 'POC Designation',
  phoneNumber: 'Phone Number',
  noOfSlots: 'No. of Parking Slots',
  reservedSlots: 'Reserved Slots',
  FCFSSlots: 'FCFS Slots',
  noOfgates: 'No. of Gates',
  noOfEVChargers: 'No. of EV Chargers',
  secondaryContact: 'Secondary Contact',
  // loginErrorMg: 'Invalid Email ID or Phone Number',
  loginErrorMg: 'Invalid Email ID',
  sentOtp:
    '4 Digit OTP has been sent to your Registered E-mail Address and Phone number.',
  reqOtp: 'Next',
  panNumber: 'PAN Number',
  panMandatory:'PAN number is mandatory',
  resend: 'Resend',
  OtpNotRec: 'OTP not received?',
  copyRight: '© Parviom Technologies Private Limited 2020',
  createLeadCorporate: 'Create Lead Corporate',
  editLeadCorporate: 'Edit Lead Corporate',
  clientName: 'Client name (Billing registered name)',
  client: "Client",
  baName : "BA Name",
  building_name: 'Buiding/Apartment Name',
  leadDetails: 'Project Details',
  LeadSource: 'Lead Source',
  mainSource: 'Main Source',
  CategoryAlliances: 'Category of Alliances',
  siteType: 'Site Type',
  siteSubType: 'Site Sub Type',
  LeadCategory: 'Project Category',
  societyType: 'Society Type',
  vms: 'VMS',
  existingsetup: 'Existing Setup',
  existingSolution: 'Existing Solution',
  marqueeSite: 'Marquee Site',
  occupancy: 'Occupancy',
  disputeLevel: 'Dispute Level',
  societyUpkeeping: 'Society Upkeeping',
  amenities: 'Amenities',
  managedBy: 'Managed By',
  securityAgency: 'Security Agency',
  maintainanceCharges: 'Maintainance Charges',
  nameError: 'Please enter a correct name.',
  aphaNumAllowed: 'Only alpha numerics allowed',
  designationError: 'Please enter a correct designation.',
  designation: 'Designation',
  mobileNumber: 'Mobile Number',
  searchNotFound: 'Search Not found.',
  businessDetails: 'Project Details',
  isRequired: 'This field is required.',
  pocTitle: 'POC Details',
  pocType: 'POC Type',
  categoryName: 'Category Name',
  othersDetail: 'Others Detail',
  createLeadSupply: 'Create Lead Supply',
  pinError: 'Incorrect pincode.',
  conf: 'Confirmation',
  error: 'Warning!',
  leadSuccess: 'Project details successfully submitted.',
  invoiceSuccess: 'Invoice details successfully submitted.',
  saveAndNext: 'Save & Next',
  PreSalesSuccess: 'Pre Sales data saved successfully',
  followUpSuccess: 'Follow up saved successfully',
  preSales: 'View  Lead Listing',
  postSales: 'View Business Listing',
  followUpSales: 'View follow Up Listing',
  createAnother: 'Create Another Lead',
  numberError: 'Number is not correct.',
  alphaNumericError: 'Special characters are not allowed',
  emailError: 'Please enter a correct email.',
  city: 'City',
  zone: 'Zone',
  area: 'Area/Sector',
  state: 'State',
  address1: 'Client Address Line 1',
  address2: 'Client Address Line 2',
  current_location: 'current location',
  remarks: 'Remarks',
  gatequantity: 'Quantity',
  lat: 'Latitude',
  lng: 'Longitude',
  geolocationNotSupport: 'Geolocation is not supported by this browser.',
  locationType: 'Location Type',
  checkinPurpose: 'Purpose Of Visit',
  pinCode: 'PIN Code',
  reqDes: 'Requirements Description',
  noOfCars: 'No. of Cars',
  noOfFlats: 'No. of Flats',
  noOfHelpingStaff: 'No. of Helping Staff',
  RWADate: 'RWA End Date',
  AverageMaintenance: 'Average Maintenance Charges/Flat',
  RWATenure: 'RWA Tenure',
  addPost: 'Add Post Sales Data',
  editContract: 'Edit Contract',
  addInvoiceNumber: 'Add Invoice Number',
  addContract: 'Add Contract',
  saveChangs: 'Save Changs',
  commercialType: 'Commercial Type',
  commercialDisc: 'Commercial Description',
  manualInvoice: 'Manual Invoice',
  increament: 'Increment',
  solution: 'Solution',
  solutionDetail: 'Solution Details',
  solutionType: 'Solution Type',
  typeIncreament: 'Type of Increment',
  installationAmount: 'Installation Amount (Excluding Taxes)',
  totalAmount: 'Total Amount (Excl. Installation & Taxes)',
  paymentTerms: 'Payment Terms',
  paymentTermsDesc: 'Payment Terms Description',
  paymentModes: 'Payment Modes',
  paymentReference: 'Payment Reference',
  totalContract: 'Total Contract Length (In Months)',
  commission: 'Commission/MDR (%)',
  requiredCommission: 'Commission is required',
  LockIn: 'Contract Lock-in Period (In Months)',
  yearlyInclin: 'Yearly Inclination',
  securityDeposit: 'Security Deposit (Excluding Taxes)',
  slotsNoFourWheeler: 'No. of Slots - Car (4-Wheeler)',
  slotsNoTwoWheeler: 'No. of Slots - Bike (2-Wheeler)',
  TagsNoPost: 'No. of Tags',
  supplyNamePost: 'Supply Name',
  detailsProvide: 'Which details do you want to provide?',
  contractType: 'Contract Type',
  agreementContract: 'Agreement Contract Details',
  agreement_Po_dtl: 'Agreement/PO Details',
  mileStone: 'Milestone Invoice Generate',
  milestoneData: 'Milestones',
  createInvoice: 'Create Invoice',
  datedInvoice: 'Dated Invoices',
  retentionInvoice: 'Retention Invoices',
  lineItem: 'Line Item',
  stage: 'Stage',
  afterStage: 'After Stage',
  afterMonths: 'After Months',
  agreementSigningDate: 'Agreement/Contract Signing Date',
  agreementContractPeriod: 'Agreement/Contract Period',
  agreementContractPeriodTo: 'Agreement/Contract Period To',
  agreementContractPeriodFrom: 'Agreement/Contract Period From',
  agreementContractLength: 'Agreement/Contract Length',
  agreementContractUpload: 'Agreement/Contract Upload',
  purchaseOrder: 'Purchase Order (P.O)',
  pONumber: 'P.O. Number',
  pODate: 'P.O. Date',
  pOUpload: 'P.O. Upload',
  opt_amount : 'Purchase Consideration Amount',
  invoice_gen:'Invoice Generation',
  pleaseUploadPO: 'Please Upload P.O',
  uploadRevDoc: 'Upload Relevant Documents',
  gstDetails: 'GST Details',
  gstRegis: 'Will GST be applicable in the invoices for this contract?',
  gstConfirmation: 'Do you have GST Number ?',
  GSTType: 'GST Type',
  gstNumber: 'GST Number (No. Of Character Check)',
  gstNumberHead: 'GST Number',
  uploadDocs: 'Upload Document',
  uploadNonGST: 'Upload Non-GST Disclosure Form',
  pleaseUploadNonGST: 'Please upload Non-GST Disclosure Form',
  gstError: "Incorrect GST format",
  GSTDocument: 'Please upload your GST Document',
  phoneError: 'Please enter correct phone number',
  valPropClient: 'Value Proposition for Client',
  valProp: 'Value Proposition',
  preSalesB2b: 'Pre Sales B2b Alliance',
  postSalesB2b: 'Post Sales B2b Alliance',
  partnerDate: 'Partner Desired Date',
  contactDate: 'Contact Date',
  operationDate: 'Operation Team Delivery Date',
  operationTitle: 'Operations Team POC',
  escalContact: 'Escalation Contact',
  otherDetail: 'Other Details',
  marketing: 'Marketing Commitment',
  vehicleType: 'Vehicle Type',
  paymentTerm: 'Payment Terms',
  newFeature: 'New Feature',
  featureDesc: 'New Feature Description',
  supplyTeam: 'Supply Team',
  supplyDeliveryDate: 'Supply Team Delivery Date',
  supplyPoc: 'Supply Team POC',
  escalationCon: 'Escalation Contact',
  productTeam: 'Product Team',
  costPerSlot: 'Cost Per Slot',
  tagNo: 'No. of Tags',
  gateFeature: 'Select Gate Feature',
  gateHead: 'Add Gates',
  valPropForUs: 'Value Proposition for Us',
  strategic: 'Strategic',
  outReach: 'Outreach',
  revenue: 'Revenue',
  bottomLine: 'Strengthing Bottom Lines',
  topLine: 'Pushing the Top Line',
  appAvail: 'App Available',
  cities: 'Major Cities',
  selectScope: 'Select Scope',
  partnerContact: 'Partner Contact & Escalation Matrix',
  Notes: 'Notes',
  parkingRules: 'Parking Rules',
  overnight: 'Overnight parking allowed',
  twowheelers: 'Two wheelers allowed to park with cars',
  timings: 'Timings',
  fromTime: 'From Time',
  toTime: 'To Time',
  anyOther: 'Any other rule',
  marketingReq: 'Marketing/signage requirement',
  expectedLive: 'Expected Live Date',
  materialHardware: 'Material/Hardware',
  tags: 'Tags',
  unitPrice:'Unit Price',
  advancePayment: 'Advance Payment',
  referenceNumber: 'Reference Number',
  tdsAmount: 'TDS Amount',
  gstAmount: 'GST Amount',
  materialHardwareReq: 'Material/Hardware Required',
  quantity: 'Quantity',
  addAnotherItem: 'Add Another Item',
  uploadSitePhotos: 'Upload Site Photos',
  uploadPaymentPhotos: 'Upload Payment Documents',
  pleaseUploadSitePhotos: 'Please Upload Site Photos',
  pleaseUploadPhotos: 'Please Upload Photos',
  uploadSiteVideos: 'Upload Site Videos',
  pleaseUploadSiteVideos: 'Please Upload Site Videos',
  pleaseUploadVideos: 'Please Upload Videos',
  uploadGatePhotos: 'Upload Gate Photos',
  uploadGateVideos: 'Upload Gate Videos',
  uploadPhotos: 'Upload Photos',
  uploadVideos: 'Upload Videos',
  agreementDocument: 'Agreement Document',
  pleaseAgreementDocument: 'Please Upload Agreement Document',
  billedTo: 'Bill To',
  shippedTo: 'Ship To',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  otherDetails: 'Other Details',
  portForwarding: 'Port Forwarding',
  scopeOfCivilWork: 'Installation Scope',
  requiredScope: 'Scope is required!',
  installationCharge: 'Installation Amt (Consumables + Labour)',
  cartage_amount:'Cartage Cost',
  installmentAmt: 'Installment',
  duration: 'Duration',
  requiredDuration: 'Required Duration!',
  increamentAmount: 'Increment Amount',
  requiredIncAmt: 'Required Increment Amount',
  rentalCharge: 'Rental Charge',
  tagCharge: 'Tag Charge',
  capexCharge: 'Capex Charge',
  installationStartDate: 'Installation Start Date',
  paymentDate: 'Payment Date',
  transactionDate: 'Cheque/Transaction Date',
  installationDeadline: 'Installation Deadline',
  isSEZ: 'If Corporate is SEZ',
  po_woNumber: 'P.O/W.O/Contract Number',
  po_woCopy: 'P.O/W.O/Contract Copy',
  pleaseUploadPo_woCopy: 'Please upload P.O/W.O/Contract Copy',
  po_woUpload: 'P.O/W.O/Contract Upload',
  gateDetails: 'Solution Details',
  clientShare: 'Client Share',
  companyShare: 'Company Share',
  costPerSlotExcludingTaxes: 'Cost Per Slot (Excluding Taxes)',
  MGSlots: 'Number of MG Slots',
  revenueSlots: 'Revenue Share Slots',
  MGPerSlot: 'MG - Cost Per Slot',
  revenueShareCostPerSlot: 'Revenue Share - Cost Per Slot (Excluding Taxes)',
  takeEtaxes: 'Take (Excluding Taxes)',
  takePerct: 'Take Percentage',
  subAmt: 'Subscription Amount (Invoice amount)',
  currentSetup: 'Current Setup',
  desiredSetup: 'Desired Setup',
  userFor: 'User For',
  amc: 'AMC',
  amcAmount: 'AMC Amount',
  hardwareRemoved: 'Any Hardware which needs to be removed?',
  hardwareDtl: 'Hardware Details',
  internetDetails: 'Internet Details',
  internetAvailabilty: 'Internet Availabilty',
  remark:'Remark',
  timeline: 'Timeline for internet Connection',
  parkCommission: 'Park+ Commission (in % w/o taxes)',
  slots4MgCar: 'No. of Slots on MG - Car (4-Wheeler)',
  slots2MgBike: 'No. of Slots on MG - Bike (2-Wheeler)',
  slotsRevenue4Car: 'No. of Slots on revenue share - Car (4-Wheeler)',
  slotsRevenue2Bike: 'No. of Slots on revenue share - Bike (2-Wheeler)',
  parkingRuleOvernight: 'Parking Rule - Overnight parking allowed',
  parkingRuleTwowheelers:
    'Parking Rule - Two wheelers allowed to park with in `car slot',
  parkingRuleTimings: 'Parking Rule- Timings',
  parkingRulePenalty: 'Parking Rule - Penalty on losing parking ticket',
  parkingRuleAny: 'Parking Rule - Any other rule',
  valetProduct: 'Valet Product Commercials',
  AdCommercials: 'Advertising Commercials',
  approachVideo: 'Approach Video',
  pleaseUploadApproachVideo: 'Please Upload Approach Video',
  marketingSignageCount: 'Marketing/Signage requirement count',
  marketingSignageType: 'Marketing/Signage requirement type',
  geoState: 'Geographical State',
  geoCity: 'Geographical City',
  location: 'Location',
  cost: 'Cost',
  siteFeatureForm: 'Site Feature',
  featureType: 'Feature',
  cinema: 'Cinema',
  cinemaName: 'Cinema Name',
  noOfScreens: 'Number of Screens',
  corporatesWthIn: 'Corporates within premises',
  keyTenant: 'Key Tenant',
  managementFeeApplicable: 'Management Fee applicable',
  managementFee: 'Management Fee in percentage',
  noOfRestaurants: 'Number of Restaurants available',
  keyRestaurants: 'Key Restaurants',
  valetAvaliable: 'Valet Available',
  noOfParking: 'Total no. of parking slots',
  noOfValetDrivers: 'Number of valet Drivers',
  enterRemarks: 'Enter Remarks',
  laneEntry: 'No. Of lanes (Entry)',
  laneExit: 'No.of lanes (Exit)',
  gateSetupTitle: 'Gates Setup',
  upload: 'Upload',
  laneDetailsTitle: 'Lane Details',
  facilitiesTitle: 'Facilities in the Vicinity',
  corporateOffices: 'Corporate offices in vicinity',
  restaurantsVicnity: 'Restaurants in vicinity',
  otherVicinity: 'Other Demand points in vicinity',
  restaurantDetailsTitle: 'Restaurant Details',
  noOfRestaurantsChain: 'No. Of restaurants in chain',
  weekdayOccupancy: 'Weekday Occupancy',
  weekendOccupancy: 'Weekend Occupancy',
  parkingDetailsTitle: 'Parking Details',
  parkingChargesType: 'Parking Charges Type',
  parkingManagementCompany: 'Parking Management Company',
  parkingEquipmentManufacture: 'Parking Equipment Manufacture',
  slotSensor: 'Slot Sensor',
  stackParking: 'Stack Parking',
  parkingEquipmentRemark: 'Parking Equipment Remark',
  otherLocationPresent: 'Other Location Present',
  preSalesLeadListing: 'Lead Listing',
  postSalesLeadListing: 'Business Listing',
  followUpListing: 'Follow Up',
  viewPOCs: 'View POCs',
  preSalesSupplyTitle: 'Add Pre Sales Data',
  addPoc: 'Add POC',
  editPoc: 'Edit POC',
  pocDetailTitle: 'Enter POC Details',
  editPocDetail: 'Edit POC Details',
  pocSucces: 'POC details submitted.',
  pocInactive: 'POC inactive successfully',
  pocList: 'View POC Listing',
  createPoc: 'Create More POC',
  preB2bSuccess: 'Details successfully submitted.',
  contractUpdate: 'Contract updated successfully!',
  preSalesB2bList: 'View List',
  name: 'Name',
  poc: 'Other POC Type',
  contact: 'Contact Number',
  productDate: 'Product Team Delivery Date',
  productPoc: 'Product Team POC',
  fixedParkingRates: 'Fixed Parking Rates',
  parkingHour: 'Parking Hour',
  parkingRate: 'Parking Rate',
  progressiveRatePerHour: 'Progressive Rate Per Hour',
  addFollowUpDetails: 'Add FollowUp Details',
  dealStatus:'Deal Status',
  AddFollowUpTitle: 'Add Follow Up',
  addPOCButton: 'Add POC',
  addExistingClient: 'Add Existing Client',
  addExistingAddress: 'Add Existing Address',
  addExistingPoc: 'Add Existing POC',
  lastInteractionDate: 'Interaction Date',
  interactionType: 'Interaction Type',
  leadDropReason: 'Lead Drop Reason',
  NotesRemarks: 'Notes & Remarks',
  currentStatus: 'Current Status',
  dropReason: 'Drop Reason',
  currentStatusStage: 'Current Status Stage',
  nextFollowUpDate: 'Next FollowUp Date',
  meetingAlignedData: 'Meeting Aligned Date',
  browseandUpload: 'Browse and Upload',
  approvals: 'Approvals',
  inspectionApprovals: 'Inspection Approvals',
  leadApproval: 'Project Approval',
  approveSuccess: 'Project details successfully Approved.',
  contractApproved: 'Contract successfully Approved.',
  approvedSuccess: 'Approved!',
  viewSites: 'View Sites',
  returnToApproval: 'Return to Approval Listing',
  rejectApproval: 'Are you sure you want to reject this lead?',
  rejectRenewalApproval: 'Are you sure you want to reject this renewal contract?',
  addRemark: 'Add Remarks...',
  rejectConf: 'Reject Confirmation',
  WorkingTimingNorms: 'Working Timing Norms',
  pickDate: 'pick Date',
  pickTime: 'pick Time',
  nextActionAgenda: 'Next Action Agenda',
  timeLineForClosure: 'TimeLine For Closure',
  siteIds: "Site ID's",
  siteId: 'Site ID',
  nextSteps: 'Next Steps',
  acceptReject: 'Approve/Reject',
  noRecord: 'Data Not Found',
  viewDetails: 'View Details',
  requestPI: 'Request PI',
  leadOwnerOrAssignee: 'Lead Owner/Assignee',
  leadType: 'Lead Type',
  fromDate: 'From Date',
  toDate: 'To Date',
  createdOn: 'Created On',
  createdBy: 'Created By',
  agentName: 'Agent Name',
  leadID: 'Lead ID',
  leadStatus: 'Lead Status',
  clientNameOrPartnerName: 'Client Name/Partner Name',
  clientBuildingOrPartnerName: 'Client,Building OR Partner Name',
  createdBetween: 'Created Between',
  lastContactDate: 'Last Contact Date',
  nextContactDate: 'Next Contact Date',
  applyFilter: 'Apply Filter',
  na: 'N/A',
  id: 'Lead ID',
  locationDetail: 'Location Details',
  baDashboard: 'BA Dashboard',
  viewSiteList: 'View Site Listing',
  loading: 'loading...',
  expectedClosure: 'Expected Closure',
  nextActionDate: 'Next Action Date',
  followUpDetails: 'Follow Up Details',
  presaleData: 'PreSales Data',
  postsaleData: 'Contract Data',
  gateFeat: 'Gate Feature',
  detailProvided: 'Details Provided',
  workTime: 'Working Time',
  address: 'Address',
  gateTitle1: 'Gate 1 Details',
  gateTitle2: 'Gate 2 Details',
  clear: 'Clear',
  addMoreGates: 'Add More',
  saveGates: 'save Gates',
  categoryInventory: 'Category Inventory',
  noGate: 'No Gates Added.',
  viewDetail: 'View Detail',
  usedFor: 'Entry Type',
  changeAssignee: 'Change Assignee',
  renewContract: 'Renew Contract',
  renewApproval: 'Renewal Approvals',
  renewlisting: 'Renewal Listing',
  existingContract: 'Existing Contract Data',
  latePayCharge: 'Late Payment Charge Per Year',
  fastag_integrable:'Fastag Entry Allowed',
  selectAssignee: 'Select Assignee',
  currentAssigne: 'Current Assignee',
  assignTo: 'Assign To',
  assignToSelf: 'Assign lead to self',
  enterField: 'Please select the field',
  oneRequired: 'One of the field is required.',
  exterior: 'Exterior Upload Photo',
  appraochRoad: 'Approach Road Upload Photo',
  parkingArea: 'Parking Area Upload Photo',
  scopeOfPartnership: 'Scope of Partnership',
  selectCategory: 'Select Category',
  selectSubCategory: 'Select Sub-category',
  revenueShare: 'Revenue Share',
  hybrid: 'Hybrid (MG & Rev Share)',
  mg: 'MG',
  capex: 'Capex',
  payPerSlot: 'Pay per Slot-Monthly',
  opexOwner: 'Opex-Ownership',
  opexRental: 'Opex-Rental',
  selectMaterial: 'Select Material',
  selectBrand: 'Select Brand',
  productInventory: 'Product Inventory',
  ParkCommission: 'Park+ Commission (in % w/o taxes)',
  otherDetailsTerms: 'Other Details',
  advertisingCommercials: 'Advertising Commercials',
  minGuarantee: 'Minimum guarantee',
  hybd: 'Hybrid',
  free: 'Free',
  oppsWrong: 'Opps! Something went wrong.',
  backToHome: 'Back To Home',
  leadListing: 'Listing',
  sales: 'Sales',
  targets: 'Targets',
  finance: 'Finance',
  financeContract:'Contract List',
  siteDashboard: 'Site Dashboard',
  siteDetail: 'Site Detail',
  showFilters: 'Show Filters',
  continue: 'Continue',
  dismentalContinue: 'Dismantle Continue',
  rejectSuccessfully: 'Rejected Successfully',
  approveReject: 'Lead Rejected Successfully.',
  approveRenewalReject: 'Contract Rejected Successfully.',
  operationTeam: 'Operation Team',
  pocNo: 'POC Phone Number',
  escalContactName: 'Escalation Contact Name',
  escalContactNo: 'Escalation Contact Phone Number',
  siteList: 'Contract Listing',
  installation: 'Installation',
  selectClient: 'Select Client',
  addClient: 'Add Client',
  addBillingAddress: 'Add Billing Address',
  billingAddress: 'Billing Address',
  clientPoc: 'Client POC',
  leadStatusupdatedsuccessfully: 'Lead status updated successfully',
  success: 'Success',
  failed: 'Failed',
  mat: 'Material',
  updatedSuccessfully: 'Updated Successfully',
  scheduleMeeting: 'Meeting',
  createMom: 'Create MOM',
  viewList: 'MOM Listing',
  addMeeting: 'Add Meeting',
  meetingHistory: 'Meeting History',
  meetingDetails: 'Meeting Details',
  feedBack: 'Feedback',
  feedbackDetails: 'Feedback Details',
  toName: 'To: Enter Name',
  selectDate: 'Select Date',
  selectTime: 'Select Time',
  summary: 'Summary',
  enterSubject: 'Enter Subject',
  subject: 'Subject',
  complaintIn90Days: 'Complaints raised in last 90 days',
  complaintResolved: 'Complaints resolved MTD',
  monthlyAverage: 'Monthly average resolution',
  uploadAttachment: 'Upload Attachment',
  uploadMultiAttachment: 'Upload Multiple Attachment',
  others: 'Others',
  othersEmail: 'Others Email',
  goToMeetingList: 'Go To Meeting List',
  meetingSuccess: 'Meeting scheduled successfully',
  meetingTrackSuccess: 'Meeting recorded successfully',
  cat: 'Category',
  product: 'Product',
  invoiceModule: 'Invoice Module',
  sub_amount: 'Subscription Amount',
  saveSuccessfully: 'Saved Successfully',
  siteListingView: 'View Site Listing',
  setTargetDate: 'Set Target Date',
  siteStages: 'Site Stages',
  stageExpectedClosure: 'Stage Expected Closure Date',
  manageStage: 'Manage Stage',
  raisedTo: 'Raised To',
  scheduledDate: 'Scheduled Date',
  scheduledTime: 'Scheduled Time',
  meetingDate: 'Meeting Date',
  meetingTime: 'meeting Time',
  distabceBetweenSiteAndUser: 'Distance B/W Site & User',
  status: 'Status',
  cancelMeeting: 'Cancel Meeting',
  rescheduleMeeting: 'Reschedule Meeting',
  markComplete: 'Mark as Complete',
  siteInspection: 'Site Inspection',
  close: 'Close',
  saveChanges: 'Save Changes',
  submit: 'Submit',
  preCampDetails: 'Pre Camp Details',
  postCampDetails: 'Post Camp Details',
  downloadSample: 'Download Sample',
  downloadFlats: 'Download Flats',
  uploadSuccess: 'Upload Successfully',
  locationNotFound: 'Location not found',
  updateLeadSuccess: 'Project updated successfully',
  updateLead: 'Updated Project',
  goToSiteList: 'Go To Site Listing',
  inventoryChecklist: 'Inventory Checklist',
  handoverChecklist : 'Handover Checklist',
  materialAddedBySale: 'Material Details (Added by Sales)',
  clientInfoForm: 'Client Information Form',
  vendorAllocation: 'Vendor Allocation',
  vendorAllocateSuccess: 'Vendor has been Allocated.',
  tickets: 'Tickets',
  toolkitInspection: 'Toolkit Inspection',
  baDashboard: 'BA Dashboard',
  createTicket: 'Create Ticket',
  ticketDetails: 'Ticket Details',
  vendorDetails: 'Vendor Details',
  enterService: 'Enter Service',
  enterQuanity: 'Enter Quantity',
  enterDesc: 'Enter Description',
  vendorCode: 'Vendor Code',
  vendorName: 'Vendor Name',
  contactPersonName: 'Contact Person Name',
  activeSites: 'Active Sites',
  serviceDetails: 'Service Details',
  civilChecklist: ' Civil Completion Checklist',
  formDetails: 'Form Details',
  hardwareInstallation: 'Hardware Installation',
  goToAllocationList: 'Go To Vendor Allocation List',
  reply: 'Reply',
  closedRM: 'Closed RM Ticket',
  replies: 'Replies',
  enterReplyDescription: 'Enter Reply Description',
  fd_ticket_id:'FD Ticket Id',
  fusion_ticket_id:'RM Ticket ID',
  ticketId: 'Ticket ID',
  leadSiteId: 'Project Site ID',
  attendance: 'Check In',
  attendanceTab: 'Attendance',
  checkInCheckout: 'Check-in/Checkout',
  darwinCheckIn: 'Check in',
  darwinCheckOut: 'Check out',
  currentLocation: 'Current location',
  comments: 'Comments',
  continueBtn: 'Continue',
  submitting: 'Submitting...',
  dynamicContents: 'Client Dashboard Content',
  addDynamicContent: 'Add Content',
  editDynamicContent: 'Edit Content',
  clientDashboardContentUpdated: 'Client dashboard content updated successfully.',
  dynamicContentCsvProjectIdColumnRequired:
    'CSV must contain a project_id column in the header row.',
  dynamicContentCsvNoIds: 'No valid project IDs found in the CSV.',
  dynamicContentCsvRuleHint:
    'Select Include or Exclude rule type to import project IDs from CSV.',
  dynamicContentCsvEditAllRuleHint:
    'Upload a CSV to set project IDs (rule will switch to Include), or select Include / Exclude above.',
  dynamicContentCsvImported: 'Imported project IDs from CSV.',
  dynamicContentProjectIdLimit: 'Maximum %s project IDs allowed.',
  dynamicContentProjectIdCount: '%s project ID(s)',
  dynamicContentProjectIdsEitherHint: 'Use either option below — not both required.',
  dynamicContentEnterProjectIdsManually: 'Type or paste project IDs',
  dynamicContentUploadCsvOption: 'Upload a CSV file',
  dynamicContentUploadCsvOptionHint:
    'Must include a project_id column',
  orLabel: 'OR',
  dynamicContentViewAllProjects: 'All projects',
  showMore: 'Show more',
  showLess: 'Show less',
  dynamicContentCsvLargeFileHint:
    'CSV import supports large lists (up to 20,000 unique project IDs).',
  deactivateDynamicContent: 'Deactivate content',
  deactivateClientDashboardContent: 'Deactivate content',
  clientDashboardContentDetails: 'Content details',
  clientDashboardContents: 'Content',
  noClientDashboardContentsFound: 'No client dashboard content found.',
  clientDashboardContentCreated: 'Client dashboard content created successfully.',
  clientDashboardContentDeactivated: 'Content deactivated successfully.',
  clientDashboardContentDeactivateFailed: 'Failed to deactivate content.',
  noClientDashboardContentImages: 'No content images uploaded.',
  dynamicContentTargetRules: 'Target & Rules',
  dynamicContentDetails: 'Content',
  dynamicContentSchedule: 'Schedule',
  targetType: 'Target Type',
  ruleType: 'Rule Type',
  targetIds: 'Comma-separated Project IDs',
  contentType: 'Content Type',
  images: 'Images',
  uploadBannerImage: 'Upload image (JPG, JPEG, PNG)',
  dynamicContentImageDimensionRequirement:
    'Requirements: height between 210px and 230px, width between 1050px and 1600px.',
  addImage: 'Add image',
  viewUploadedImage: 'View uploaded image',
  redirectUrl: 'Redirection URL (optional)',
  dynamicContentRedirectUrlInvalid:
    'Redirection URL must start with http:// or https://',
  dynamicContentRedirectUrlHint:
    'If provided, redirection URL must start with http:// or https://',
  title: 'Title',
  dynamicContentTitleRequired: 'Title is required.',
  dynamicContentStartDateRequired: 'Start date is required.',
  dynamicContentEndDateRequired: 'End date is required.',
  dynamicContentStartDatePast: 'Start date cannot be in the past.',
  checkOut: 'Check Out',
  startjourney: 'Start Journey',
  endjourney: 'End Journey',
  todayAttendance: 'Today Attendance',
  todayAttendanceList: "Today's Attendance List",
  loremIpsum: 'Lorem Ipsum Listing',
  type: 'Type',
  department: 'Department',
  attachment: 'Attachment',
  changeStatus: 'Change Status',
  raiseTicket: 'Raise Ticket',
  vendorAllocated: 'Vendor Allocated',
  locationApprovals: 'Location Approvals',
  siteAbortApproval: 'Site Hold/Abort Approvals',
  viewSiteStages: 'View Site Stages',
  validateLocation: 'Validate Location',
  approve: 'Approve',
  approvedBy : 'Approved By',
  approvedDate : 'Approval Date',
  handoverTesting: ' Handover & Testing',
  generateMRF: 'Generate Material Requisition Form',
  mrf: ' Material Requisition Form',
  consolidateReport: 'Consolidate Report',
  UploadSiteLayout: 'Upload Site Layout',
  clientSignature: 'Upload Client Sign.',
  capturePOC: 'Upload Capture POC',
  siteImages: 'Upload Site Images ',
  materialAdded: 'Material Added',
  requestforApproval: 'Request for Approval',
  sendtoProcurement: 'Send to Procurement',
  productCategory: 'Product Category',
  productName: 'Product Name',
  productCode: 'Product Code',
  hsnCode: 'HSN Code',
  inventoryChecklistNote: 'Fill the Inventory Checklist for all gates',
  ChecklistNote: 'Fill Checklist Form for all gates',
  note: 'Note',
  actions: 'Actions',
  action: 'Action',
  email: 'Email',
  mobileNo: 'Mobile No.',
  userRole: 'User Role',
  team: 'Team',
  enggName: 'Engg. Name',
  enggID: 'Engg. ID',
  stageStatus: 'Stage Status',
  generateReport: 'Generate Report',
  notify: 'Send',
  stageCompleted: 'Stage Completed',
  materialDelivery: 'Material Delivery',
  tagDelivery: 'Tag Dispatch',
  invoiceNo: 'Invoice No',
  challanNo: 'Challan No',
  poNo: 'PO No',
  poAmt: 'PO Amount',
  deliveredQuantity: 'Delivered Quantity',
  receiveQuantity: 'Receive Quantity',
  requestedQuantity: 'Requested Quantity',
  bOQAssignment: 'BOQ Assignment',
  continueWithBOQ: 'Continue with BOQ',
  pRCreated: 'PR Created',
  allocateVendor: 'Allocate Vendor',
  locationPermission:
    'In order to submit the form you need to allow the location first',
  siteEngineer: 'Site Engineer',
  locationApprovalRejected: 'Your Location Request is Rejected',
  locationDoesNotMatch: 'Your Location does not match',
  stateUpdateSuccess: 'Status Updated Successfully.',
  viewSiteListing: 'View Site Listing',
  viewSiteInformation: 'View Site Information',
  sentForApprovalSuccess: 'Your Request has been sent for Approval ',
  viewCivilChecklist: 'View Civil Checklist',
  viewHardwareInstallation: 'View Hardware Installation',
  viewHandoverTesting: 'View Handover Testing',
  mrfRaisedDate: 'MRF Raised Date',
  raisedBy: 'Raised By',
  mrfDate: 'MRF Date',
  cityHeadResponseDate: 'City Head Response Date',
  viewMRF: 'View Material Requisition Form',
  gateNumber: 'Gate Number',
  gateType: 'Gate Type',
  currentDate: 'Current Date',
  gateName: 'Gate Name',
  material: 'Material',
  quantityAllocated: 'Quantity Allocated',
  reportSuccess: 'Report is successfully generated ',
  reportGenerating: 'Report will be generated.',
  sentToProcurementSuccess: 'Successfully sent for Procurement ',
  mrfMessage: 'Please complete MRF Process',
  mailSuccessfully: 'Email Successfully Send',
  accept: 'Accept',
  mrfApprovals: 'MRF Approvals',
  mrfRejection: 'Are you sure you want to reject this MRF?',
  mrfApproveReject: 'MRF Rejected Successfully.',
  viewTicketsList: 'View Tickets List',
  approvedSuccessfully: 'Approved Successfully',
  locationApprovalPending: 'Your Location Request is pending for approval',
  uploadReferenceDocument: 'Upload Reference Document',
  checkboxIsRequired: 'Checkbox field are required',
  addAnotherGate: 'Add Another Gate',
  remove: 'Remove',
  loding: 'loding...',
  uploadError: 'Upload site layout and client details before submitting form',
  maintenance: 'Maintenance',
  goLiveSites: 'Go Live Sites',
  AccessDenied: 'Access denied',
  notAccess: "you don't have access to this page",
  goBack: 'Go Back',
  quatityGreaterMsg: 'Entered Quantity should is less than requested quantity',
  sitesLocationMap: 'Sites Location Map',
  createComplain: 'Create Complain',
  fileComplain: 'File Complain',
  siteInformation: 'Site Information',
  complaintFilter: 'Site Filter',
  Filter:'Filter',
  clientAddress: 'Client Address',
  clientEmail: 'Client Email',
  secondContact: 'Secondary Contact',
  emailId: 'Email Id',
  requiredSiteId: 'Site Id is required',
  complainRaisedBy: 'Complain Raised By',
  complainType: 'Complain Type',
  gate: 'Gate',
  productType: 'Product Type',
  materialRequired: 'Material Required',
  addDescription: 'Add Description',
  pleaseUploadAttachment: 'Please upload attachment!',
  siteInfoError: 'Please select/filled at least one',
  getSiteDetails: 'Get Site Details',
  getData: 'Get Details',
  cancel: 'Cancel',
  raiseComplain: 'Raise Complain',
  siteDetails: 'Site Details',
  addCategory: 'Add Category',
  subcategory: 'Sub-Category',
  viewPMChecklist: 'View PM Checklist',
  createPMChecklist: 'Create PM Checklist',
  gateCheckList: 'Gate CheckList',
  addACategory: 'Add a Category',
  pmSities: 'PM Sites',
  preventiveMaintenance: 'Preventive Maintenance',
  viewPmList: 'View PM List',
  questionRequired: 'This question is required',
  pendingTask: 'Tasks to be taken up in this PM',
  downloadPmList: 'Download PM List',
  uploadPmList: 'Upload PM List',
  selectMonth: 'Select Month',
  selectYear: 'Select Year',
  uploadYourFile: 'Upload Your File',
  employeeTickets: 'Employee Tickets',
  employeeTicket: 'Employee Ticket',
  pmTickets: 'PM Tickets',
  ticketsDetails: 'Ticket Details',
  assign: 'Assign',
  scheduleMaintenance: 'Schedule Maintenance',
  scheduleMaintenanceDate: 'Schedule Maintenance Date',
  assignTickets: 'Assign Tickets',
  assignedSuccessfully: 'Scheduled successfully',
  rmTicketAssigned : 'RM Ticket Assigned',
  viewPMTickets: 'View PM Tickets',
  selectStatus: 'Select Status',
  pleaseConfirmStatus: 'Please confirm the status of this ticket.',
  pleaseConfirm: 'Please confirm the status.',
  createEmployeeTicket: 'Create Employee Ticket',
  selectSiteName: 'Select Site Name',
  ticketSuccessfullyCreated: 'Ticket Successfully Created',
  complainList: 'Complain List',
  viewComplain: 'View Complain',
  complainDetails: 'Complain Details',
  complainId: 'Complain ID',
  siteName: 'Site Name',
  raisedTicketsDetails: 'Raised Tickets Details',
  closeComplain: 'Close Complain',
  reopenComplain: 'Reopen Complain',
  save: 'Save',
  assignEngineer: 'Assign Engineer',
  createMRF: 'Create MRF',
  pmScheduleMonth: 'PM Schedule Month',
  maintenanceDate: 'Maintenance Date',
  currentMaintenanceDate: 'Current Maintenance Date',
  managePm: 'Manage Preventive Maintenance',
  schedulePm: 'Schedule Preventive Maintenance',
  assignSiteEngineer: 'Assign Site Engineer',
  approvalPmTickets: 'Approval - PM Tickets',
  approvalPmSites: 'Approval - PM Sites',
  approvalEmTicket: 'Approval - EM Tickets',
  replyDate: 'Reply Date ',
  repliedBy: 'Replied by',
  response: 'Response',
  closeComplainConfirmation: 'Are you sure you want to close this complain?',
  statusupdatedsuccessfully: 'Status updated successfully',
  complainClosedSuccessfully: 'Complain closed successfully',
  approvePmTicket: 'Approve PM Ticket',
  selectCondition: 'Select Condition',
  approvalCondition: 'Please select approval condition',
  userApprovalLevel: 'User Approval Level',
  materialApproved: 'Material Successfully approved.',
  manageSiteEngineer: 'Manage Site Engineer',
  numberShouldBeDifferent: 'Number should be different',
  reactiveMaintenance: 'Reactive Maintenance',
  supportedFormat: ' Supported format(.pdf,.png,.jpg,.jpeg,.doc)',
  uploadSupportingDocument: 'Upload Quotation',
  quotation: 'Quotation',
  approveQuotation: 'Approve Quotations',
  quotationHistory: 'Quotation History',
  noDataFound: 'No Data Found',
  po: 'P.O.',
  nonGSTDisclosureForm: 'Non-GST Disclosure Form',
  sitePhotos: 'Site Photos',
  siteVideos: 'Site Videos',
  photos: 'Photos',
  videos: 'Videos',
  image: 'Image',
  video: 'Video',
  attachmentAgreement: 'Agreement',
  removeFilter: 'Remove Filter',
  leadNumber: 'Lead Number',
  siteNumber: 'Site Number',
  mrfNumber: 'MRF Number',
  
  uploadQuotationIsRequired: 'Upload Quotation is required',
  pinCodeIsNotAvailable: 'PIN code is not available',
  ticketingMethod: 'Ticketing Method',
  referenceDocument: 'Reference Document',
  commercialDetails: 'Commercial Details',
  partnerLogo: 'Partner Logo',
  deliveryDate: 'Delivery Date',
  partnerParketingCommitment: 'Partner Parketing Commitment',
  parkMarketingCommitment: 'Park Marketing Commitment',
  partnerLogoUpload: 'Partner Logo Upload',
  agreementTnCUpload: 'Agreement/T&C Upload',
  assignedArea: 'Assigned Area',
  siteStatus: 'Site Status',
  reportee: 'Reportee',
  reportingTo: 'Reporting To',
  latValue: 'Latitude value should be same as longitude',
  logValue: 'Longitude value should be same as Latitude',
  expectedClosureDate: 'Expected Closure Date',
  viewEMTickets: 'View EM Tickets',
  viewRMTickets: 'View RM Tickets',
  approvalRmTickets: 'Approval - RM Tickets',
  rmTickets: 'RM Tickets',
  rmTicket: 'RM Ticket',
  viewChecklistReport: 'View Checklist Report',
  siteInspectionDetails: 'View Site Inspection Details',
  materialRequirement: 'Material Requirement',
  troubleshoot: 'Troubleshoot',
  troubleshootSucess: 'Troubleshoot Successfully Completed',
  siteNumber: 'Site Number',
  complainDescription: 'Complain Description',
  recordNotFound: 'Record not found for this month',
  downloadedSuccessfully: 'Downloaded Successfully',
  uploadedSuccessfully: 'Uploaded Successfully',
  pmChecklist: 'PM Checklist',
  assignedTo: 'Assigned To',
  scheduleFirstMaintaince: 'Schedule Maintaince',
  meetingCancelSuccess: 'Meeting cancelled successfully',
  complain: 'Complain',
  complains: 'Complains',
  sitesMap: 'Sites Map',
  customCategory: 'Custom Category',
  viewTicketDetails: 'View Ticket Details',
  sitesLocationMapping: 'Sites Location Mapping',
  allocatedSiteList: 'Allocated Sites List',
  exteriorUploadPhotoRequired: 'Exterior Upload Photo is required',
  parkingAreaUploadPhotoRequired: 'Parking Area Upload Photo is required.',
  approachRoadUploadPhotoRequired: 'Approach Road Upload Photo is required',
  clientType: 'Client Type',
  requiredClientType: 'Client Type is Required',
  validDataForNoOfGates: 'Please enter valid data for No of gates',
  picodeRequired: 'PIN code is required',
  emailAddressRequired: 'Email Address is required',
  enterValidData: 'Please enter valid data.',
  meetingCompleted: 'Meeting completed',
  exportList: 'Export List',
  brandActivation: 'Brand Activation',
  viewMom: 'View MOM',
  selectMeetingDate: 'Select Meeting Date',
  selectMeetingTime: 'Select Meeting Time',
  meetingTracker : 'Meeting Tracker',
  meetingOrganisorName: 'Meeting Organisor Name',
  meetingOrganisorRequired: 'Meeting Organisor is required!',
  meetingLocation: 'Meeting Location',
  meetingLocationRequired: 'Meeting Location is required!',
  attendeesName: 'Attendees Name (Comma Separated)',
  attendeesNameRequired: 'Attendees Name is required!',
  meetingAgenda: 'Meeting Agenda',
  subMeetingAgenda: 'Sub Meeting Agenda',
  meetingDescription: 'Meeting Description',
  meetingDescriptionRequired: 'Meeting Description is required!',
  momCreatedSuccessfully: 'MOM Created Successfully',
  momDetails: 'MOM Details',
  meetingOrganisor: 'Meeting Organisor',
  meetingLoc: 'Meeting Location',
  attendees: 'Attendees Name',
  meetingDesc: 'Meeting Description',
  meetingMarkedCompleted: 'Meeting Marked as Completed',
  products: 'Products',
  knowledgeCenter: 'Knowledge Center',
  rmReport: 'RM Ticket Report',
  addToCart: 'Add to Cart',
  qty: 'Qty.',
  addedTocart: 'Product Added in Cart.',
  qtyRequired: 'Quantity is Required.',
  checkout: 'Checkout',
  campListing: 'Camp Listing',
  scheduleCampMeeting: 'Schedule Camp Meeting',
  carnivalName: 'Carnival Name',
  carnivalListing: 'Carnival Listing',
  helpdeskListing: 'Helpdesk Listing',
  scheduleCarnival: 'Schedule Carnival',
  scheduleHelpdesk: 'Schedule Helpdesk',
  helpdeskDetails: 'Helpdesk Details',
  carnivalDetails: 'Carnival Details',
  infraIdNotFound: 'Infra Id not found. Please contact admin.',
  projectOnboard: 'Project Onboarding',
  onboardProject: 'Add Project',
  editProject: 'Edit Project',
  businessAddresses: 'Business Addresses',
  projectList: 'Projects List',
  projectOnboardRequest: 'Onboard Request',
  projectDetails: 'Project Details',
  projectSearch: 'Project Search',
  projectType: 'Project Type',
  addNewProject:'Add New Project',
  updateProject:'Update Project',
  goBackList:'Go Back',
  projectId: 'Project Id',
  projectName: 'Project Name',
  societyName: 'Society Name',
  enterSocietyName: 'Enter Society Name',
  startDate: 'Start Date',
  startTime: 'Start Time',
  endDate: 'End Date',
  endTime: 'End Time',
  memberDetails: 'Member Details',
  addMembers: 'Add Members',
  services: 'Services',
  requiredServices: 'Required Services',
  serviceName: 'Service name',
  promocode: 'Promo Code',
  requiredPromo: 'Required Promo Code',
  price: 'Price',
  requiredPrice: 'Required Price',
  requiredStatus: 'Required Status',
  carnivalSuccess: 'Carnival scheduled successfully',
  carnivalUpdateSuccess: 'Carnival Updated successfully',
  helpdeskSuccess: 'Helpdesk scheduled successfully',
  helpdeskUpdateSuccess: 'Helpdesk Updated successfully',
  goToHelpdeskListing: 'Go to Helpdesk Listing',
  campSuccess: 'Camp scheduled successfully',
  carnivalStatusUpdate: 'Carnival Status Update successfully!',
  goToCarnivalListing: 'Go to Carnival Listing',
  carnivalLink: 'Carnival URL',
  qrLink: 'QR URL',
  uploadCarnivalImage: 'Upload Carnival Image',
  amountgateAmt: 'Total Amount',
  gateAmount: 'Gate Amount',
  gateMonthlyRentalAmount: 'Gate Monthly Rental Amount',
  installationCost: 'Installation Cost',
  parkingSlot : 'No of parking slots',
  carSlot : 'Car Slots',
  bikeSlot : 'Bike Slots',
  otherSlots: 'Other Slots',
  occupancyCars: 'Car Occupancy',
  occpancyBike: 'Bike Occupancy',
  entryGates: 'Entry Gates',
  exitGates: 'Exit Gates',
  parkingFloors: 'Parking Floors',
  parkingRevenue: 'Parking Revenue',
  parkingAgency: 'Parking Agency',
  addPhotos: 'Add Photos',
  sellingCar : 'Selling Cost of Car Slot',
  purchaseBike : 'Purchase cost of bike slot',
  sellingBike : 'Selling Cost of Bike Slot',
  purchaseCar : 'Purchase cost of car slot',
  basemment : 'No of Basements',
  valetDriver : 'No. of valet Driver',
  valetSup : 'No. of valet Supervisor',
  valet_driver_cost : "Cost of Valet driver",
  valet_sup_cost : "Cost of Valet Supervisor",
  valet_attendant : "No. of valet attendant",
  valet_attendent_cost:'Cost of Valet attendant',
  software_cost:'Software Cost',
  charger_type : 'Type of charger',
  management_fee:'Management fee %',
  miscellaneous_cost:'Miscellaneous one-time cost',
  revenue_share:'Revenue share %',
  profit_share:'profit Share %',
  damageLiability : 'Damage Liability cover provided?',
  SWPaymentType : 'Software Payment type',
  premium : 'Premium charged',
  transAmount: 'Transaction Amount',
  utrNumber: 'UTR Number',
  chequeAttachment: 'Cheque Attachment',
  goToCampListing: 'Go To Camp Listing',
  typeOfMeeting: 'Type Of Meeting',
  paid: 'Paid',
  campMeetingDetails: 'Camp Meeting Details',
  momDate: 'MOM Date',
  momTime: 'MOM Time',
  selectMomDate: 'Select Mom Date',
  selectMomTime: 'Select Mom Time',
  promoterDetails: 'Promoter Details',
  isPlaceOrder: 'Are you sure to place the order?',

  orderSuccessfullyPlaced: 'Your Order has been Successfully Placed.',
  manageCorporateClient: 'Manage Corporate Client',
  addCorporateClient: 'Add Corporate Client',
  companyName: 'Company Name',
  clientDetails: 'Client Details',
  employeeCount: 'Employee Count',
  requiredCompanyName: 'Company Name is required',
  corpClientAddedSuccessfully: 'Corporate Client added successfully',
  goToCorporateClientList: 'Go To Corporate Client List',
  invoice: 'Invoice',
  invoiceDate: 'Invoice Date',
  paymentDueDate: 'Payment Due Date',
  updateClient: 'Update Client',
  update: 'Update',
  rmClosingDetails: 'RM Closing Details',
  tktCompletionDetails: 'Ticket Completion Details', 
  delayDueTo: 'Delayed Due To',
  closeReason: 'Close Reason',
  remarkRunning: 'Remarks (Running commentary)',
  generalRemark: 'General Remarks',
  criticality: 'Criticality',
  issueRelated: 'Issue Related',
  clientMsg: 'Are you sure you want to delete this client?',
  mrfDetailMsg: 'Are you sure you want to delete this Mrf Detail?',
  delete: 'Delete',
  yes: 'Yes',
  preCamp: 'Pre Camp',
  postCamp: 'Post Camp',
  addPostCampSuccess: 'Post camp training successfully saved',
  addPreCampAnsSuccess: 'Pre camp successfully saved',
  makePayment: 'Make Payment',
  receivedAmount: 'Received Amount',
  receivedDate: 'Received Date',
  paymentMode: 'Payment Mode',
  requestedAmt: 'Requested Amount',
  requestAmt: 'Request Amount',
  requestedDate: 'Requested Date',
  UTR_number : 'UTR Number',
  paymentDueDays: 'Payment Due Days',
  tdsDeducted: 'TDS Deducted',
  retentionAmount: 'Retention Amount',
  retentionUTR: 'Retention UTR',
  paymentUtr: 'Payment UTR',
  payableAmount: 'Payable Amount',
  bulkAssignment: 'Change Assignee',
  bulkHoldApproval: 'Approve Hold Payment',
  otherLeadSource: 'Other Lead Source',
  mandatoryField: 'This field is mandatory',
  enterOtp: 'Please enter 4 Digit OTP',
  pleaseUploadAgreementContract: 'Please Upload Agreement/Contract',
  body: 'Body',
  sureAllocateVendor: 'Are you sure you want to allocate site to the vendor?',
  approvedSalesLeadListing: 'Contract Listing',
  contractListing: 'Contract List',
  otpResndMsg: 'OTP has been resend to your number.',
  details: 'Details',
  vendorPortal:'Vendor Portal',
  vendorReq: 'Vendor Request',
  vendorPaymentList : 'Payment List',
  vendorPaymentDetail : 'Payment Detail',
  addRequest : 'Add Payment Request',
  expense_basis: 'Expense Basis',
  expense_type: 'Expense Type',
  vendorPaymentRequest: 'Vendor Payment Request',
  vendorPaymentRequestApprovalList : 'Payment Request Approval',
  paymentApprovalDetails : 'Payment Request Approval Details',
  vendoronboard: 'Vendor Onboard',
  taxableAmt: 'Taxable Amount',
  lob:'LOB',
  retentionPer : 'Retention %',
  freightAmt: 'Freight Amount',
  otherAmt: 'Other Charges',
  cgst:'CGST Amount',
  sgst:'SGST Amount',
  igst:'IGST Amount',
  totalAmountIncludeTax: 'Total Amount (Including Tax)',
  totalRequestedAmount: 'Total Requested Amount',
  pendingAmt:'Pending Amount',
  firmName: 'Firm Name',
  paymentPortal:'Payment Portal',
  businessList :'Business List',
  PaymentRequestList :'Request List',
  taxInv :'Tax Invoice',
  performaInv :'Performa Invoice',
  vendorFirm: 'Vendor Firm',
  addedSuccessfully: 'Added Successfully',
  repliedSuccessfully: 'Replied Successfully',
  rejectCamp: 'Are you sure you want to reject this camp?',
  reject:"Reject",
  campRejectSuccess: 'Camp Rejected Successfully',
  campApprovalSuccess: 'Camp successfully Approved',
  approveConductCamp: 'Approve Conduct Camp',
  assignee: 'Assignee',
  plannedDeliveryDate: 'Planned Delivery Date',
  actualClosureDate: 'Actual Closure Date',
  myProfile: 'My Profile',
  organizationHierarchy: 'Organization Hierarchy',
  you: 'You',
  reportsTo: 'Reports To',
  yourTeam: 'Your Team',
  showFullChain: 'Show full chain',
  showLess: 'Show less',
  levelsAbove: 'levels above',
  directReportees: 'direct reportees',
  totalInTeam: 'total in team',
  directLabel: 'Direct',
  totalReporteesLabel: 'Total Reportees',
  noHierarchyFound: 'No managers or reportees found in your hierarchy.',
  salesTeamMember: 'Sales Team Member',
  salesMemberDesignation: "Sales Member's Designation",
  mrfId: 'MRF ID',
  amount: 'Amount',
  requiredGateAmount: 'Gate Amount is required!',
  mailCamp: 'Include in Mail Campaign',
  strategicPartnerselect: 'Select Partner',
  holdReason : 'Hold Reason',
  strategicPartner: 'Strategic Partner',
  firstName: 'First Name',
  lastName: 'Last Name',
  supervisor: 'Supervisor',
  supervisorList: 'Supervisor List',
  valetList: 'Valet List',
  valet: "Valet",
  panCard: 'Pan Card',
  drivingLicence:'Driving Licence',
  aadharCard:'Aadhar Card',
  incentivelab: 'Incentive Slab (Project level)',
  gmc: 'gcm',
  rating: 'Rating',
  OnlineTax: 'Online Tax',
  dropTat: 'Drop Tat',
  search: 'Search',
  zoneSelectionType: 'Zone Selection Type',
  allowGetMyCar: 'Allow Get My Car',
  allowArrivedNotification: 'Allow Arrived Notification',
  allowDeliveryNotification: 'Allow Delivery Notification',
  allowParkedNotification: 'Allow Parked Notification',
  prePayment: 'Pre Payment',
  addProject: 'Add Project',
  start: 'start',
  end: 'end',
  profile: 'Profile',
  mondayPrice: "Monday Price",
  tuesdayPrice: "Tuesday Price",
  wednesdayPrice: "Wednesday Price",
  thursdayPrice: "Thursday Price",
  fridayPrice: "Friday Price",
  saturdayPrice: 'Saturday price',
  sundayPrice: 'Sunday Price',
  holidayPrice: 'Holiday Price',
  fitkit: 'FITKIT Integrable',
  rfid: 'Buy Tag Enabled',
  fitkitPrice: 'FITKIT Price',
  rfidPrice: 'RFID Price',
  FITKITRFIDDetails: 'FITKIT And RFID Details',
  normalOnboardingListing: "Society Onboarding",
  createNew: 'Create New',
  societyOnboarding: "Society Onbroading",
  pmSiteApproval:"Site Disable/Enable",
  approvePmSiteSuccess: 'site successfully Approved.',
  iAmAtSite: 'I am working on site',
  iAmAtRemotely:'I am working remotely',
  whereAreYou:'Where are you?',
  howAreYouClosingThisSiteStage:'How are you closing this site stage',
  throughVideoCall:'Through video Call',
  throughVoiceCall:'Through voice call',
  zoneListing:'Zone Listing',
  reason:'Reason',
  isSaas:"is Saas",
  pmcAllowedPaymentMethod:'PMC Allowed Payment Methods',
  gmcAllowedPaymentMethod:'GMC Allowed Payment Methods',
  eta:'ETA',
  isProgressive:'Is Progressive',
  isImageSkippableSite:'Is Image Skippable Site',
  baseHours:'Base Hours',
  ProgressiveCharge:'Progressive Charge',
  hours:'Hours',
  content:"Content",
  assignedUser:'Assigned User',
  changeAssignedUser : "Change Assigned User",
  ChangeAssignee:'Change Assignee',
  editValetProject: 'Edit Project',
  updateValetProject: 'Update Project',
  caption:'Caption',
  projectOnboarding:'Project Onboarding',
  projectStatus:'Project Status',
  siteRepository:'Site Repository',
  addSiteRepository:'Add Site Repository',
  siteRepositoryListing:'Listing',
  documentType:'Document Type',
  media:'Document',
  dailyTask:'Daily Task Activities',
  addDailyTask: 'Add Daily Task',
  tasks: 'Tasks',
  enggtasklisting: 'Task Listing',
  addtask: 'Add Task',
  site: 'Site',
  sendL2Ticket: 'Send L2 Support Ticket',
  createTask: 'Create Task',
  networkEngineerTask: 'Network Engineer Task',
  siteIncentive:'Site Incentive',
  incentiveList: 'Incentive List',
  addIncentive: 'Add Incentive',
  incentiveFor: 'Incentive For',
  salesApprovedIncentiveList: 'Sales Approved Incentive List',
  rejectIncentive: 'Are you sure to reject this incentive',
  returnToIncentive: 'Return To Incentive Listing',
  approveIncentiveScccess: 'Incentive Approved Successfully.',
  userIncentives: 'User Incentives',
  seniorIncentives: 'Senior Incetives',
  incentiveLists: 'Incentive Lists',
  uploadUtr: 'Upload UTR',
  uploadUserUtr: 'Upload User UTR (CSV File)',
  uploadSeniorUtr: 'Upload Senior UTR (CSV File)',
  utrUploadedSuccessfully: 'UTR Uploaded Successfully.',
  headIncentive: 'Head Incentives',
  incenitvePortal: 'Incentive Portal',
  materialRequistionForm:"Material Requistion Form",
  SiteNo:"Site No",
  siteAddress:"Site Address",
  planDeliveryDate:'Planned Delivery Date',
  contactName: 'Contact Name',
  MaterialRequirement:'Material Requirements',
  UnclaimedTransaction: 'Unclaimed Transaction',
  materialTypes:'Material Types',
  slocWarehouse:'SLOC(WareHouse)',
  no:'No',
  employeeName:'Employee Name',
  ASM:'ASM',
  scope:"Scope",
  is_billable: 'Will client pay for this MRF ?',
  pi_no: "Performa Invoice No",
  AM:"AM",
  businessType:'Business Type',
  paymentReceived:'Payment Received',
  materialsServiceType:'Material Service Type',
  materialDetails:'Material Acquisition Details',
  materialAcquisitionLineItems: 'Material Line Items',
  materialAcquisition: 'Material Acquisition',
  uploadedDocument:"Manager Upload Document",
  materialApproval:'MRF Approval/Reject Listing',
  remarkForStore:'Remark for store',
  remarkForApprover:'Remark For Approver/Finance',
  modeOfTransport:'Mode of transport',
  clientScopeUploadedDocument: 'Client Scope Uploaded Document',
  invoiceAmount:'Invoice Amount',
  remarksBy:'Remarks by',
  holdAndApproved: 'Hold & Approved',
  returnToPaymentRequest: 'Return To Payment Request Approval',
  installationCertificate: 'Installaton Certificate',
  agreementAttachment: 'Attach Agreement',
  otherAttachment: 'Other Attachment',
  loginWithGoogle: 'Login With',
  installationId: 'Installation Id',
  msmeRemark: 'MSME Remark',
  msmeAmount: 'MSME Amount',
  msmeRate: 'MSME Rate',
  chequeUTRNo: 'Cheque UTR No.',
  chequeUTRPhoto: 'Cheque UTR Photo.',
  chequeUTRDate: 'Cheque UTR Date.',
  tiGenerated: 'TI Generated',
  invoices: 'Invoices',
  creditLimitLedger: 'Credit Limit Ledger',
  from:"From",
  fromSite:"From Site",
  store:"Store",
  toClientName: 'Client name',
  uploadPaymentProof: 'Upload Payment Proof',
  gateCount: 'Gate Count',
  optedGateNo: 'Opted on number of gate',
  planDate: 'Start date of plan',
  disableOption: 'Disable option',
  anprCameraFixed: 'ANPR camera is properly fixed or not as per vehicle movement?',
  roiSet: 'ROI set as per requirement',
  handOverDate: 'Handover testing date',
  contractValidity: 'Contract validity (No. of months)',
  addNewComplain:'Add New Complain',
  editComplain: 'Edit Complain',
  detailComplain: 'Complain Detials',
  taxInvLob :'Tax Invoice(LOB)',
  changeTIAssignee : "Change TI Assignee",
  firstInteractionComplete: 'First Interaction Checklist Completion',
  configurationAndTesting: 'Configuration Testing Checklist Completion',
  viewFirstInteractionChecklist: 'View First Interaction Checklist',
  viewConfigTestingChecklist: 'View Configuration Testing Checklist',
  transaction: 'Transaction',
  addWalletMoney:"Add Money",
  wallet:'Wallet',
  approvalConf: 'Approval Confirmation',
  areYouSure : 'Are you sure to continue...',
  returnToList: 'Return to wallet transaction list',
  walletList: 'List',
  walletApproval: 'Approval',
  approveTransactionSuccess: 'Transaction Approved Successfully.',
  rejectTransactionSuccess: 'Transaction Rejected Successfully.',
  downloadTransactions: 'Download Trasaction',
  tagMismatchApproval: 'Tag Mismatch Approval',
  opsQty: 'Ops Qty',
  tagSendForApproval: 'Tag sent for approval',
  goToApprovalListing: 'Go to Approval Listing',
  rejectTagMismatch: 'Are you sure you want to reject this mismatch?',
  claimDetails: 'Claim Details',
  claimCreatedSuccess: 'Claim raised successfully',
  inventory:'Inventory',
  isOrganized: 'Is Organised',
  isOrganizedRequired: 'Is Organized is required',
  hoto: 'HOTO',
  hotoInstListing: 'HOTO Installation Listing',
  hotoMainListing: 'HOTO Maintenance Listing',
  hotoInstApproval: 'Installation Approval',
  hotoMainApproval: 'Maintenance Approval',
  siteAssignSuccess: 'Site assigned successfully',
  hotoForm: 'HOTO Form',
  installHotoForm: 'Installation HOTO Form',
  rejectAndSend: 'Reject & Send',
  rejectHotoApproval: 'Are you sure you want to reject this Hoto?',
  addMaterial: 'Add Material',
  issueEncountered: 'Issue Encountered',
  deptDepend: 'Dependant Department',
  empMrf: 'Employee MRF',
  transactionId: 'Transaction Id',
  description: 'Description',
  modeOfCollection: 'Mode of Collection',
  serialNo: 'Serial No',
  addBusiness: 'Add Business',
  addAddress: 'Add Address',
  addressDetails: 'Address Details',
  addClientAddress : 'Add Client Address',
  searchLocation : 'Search Location',
  clientList :'Client List',
  panAndGstDetails: 'PAN & GST Details',
  rejectRequest: 'Are you sure to reject this Request',
  postponeInstallationApprovals: 'Postpone Date Approvals',

  // Solution Card
  solutionName: 'Name',
  solutionAmc: 'AMC',
  enterMrf: 'Enter MRF ID',
  tsList: 'Transfer Shipment Listing',
  materialReceive: 'Material Receive',
  matReceiveForm: 'Material Receiving Form',
  solutionName: 'Name',
  solutionAmc: 'AMC',
  clientNameFilter: 'Client Name',
  civilScope: 'Civil Scope',
  electricalScope: 'Electrical Scope',
  updatePoc: 'Update POC Details',
  projectConfiguration: 'Project Configuration',
  noEntryGates: 'Number Of Entry Gates',
  noExitGates: 'Number Of Exit Gates',
  entry_exit_gates: 'Number Of Entry-Exit Gates',
  gate_number: 'Gate Number',
  gate_type: 'Gate Type',
  device_name: 'Device Name',
  device_type: 'Device Type',
  pc_dropdown: 'Site Type',
  gate_detail: 'Gate Details',
  chequeNo: 'Cheque Number',
  chequeAmt: 'Cheque Amount',
  chequePicked: 'Cheque Picked',
  chequeReason: 'Reason for not picking cheque',
  chequeStatus: 'Cheque Status',
  dailyTaskAndIssueEncounter : 'Daily Task & Issue Encountered',
  projectsUpdates : 'Project Updates',
  searchTag : 'Search Tag',
  tagDetails : 'Tag Details',
  projectVehicleDetails : 'Project Vehicle Details',
  tagAuditLog : 'Tag Audit Log',
  activityLog : 'Activity Log',
  increaseCreditLimit: 'Increase Credit Amount',
  currentAmount: 'Current Limit',
  holdAmount: 'Hold Amount',
  owedAmount: 'Owed Amount',
  creditLimit: 'Credit Limit',
  tillDate: 'Till Date',
  totalLimit : "Total Limit",
  userCreditLimit: "User Credit Limit",
  tagList: "Tag List",
  tagCount: 'Add Tag Count',
  gmcMandatoryCount: "GMC Mandatory Count",
  isPrebookingAllowed: "Is Prebooking Allowed",
  operationStartDate: "Operational Start Date",
  operationEndDate: "Operational Start End",
  operationDays: "Operational Days",
  flowTypes: "Flow Types",
  passTypeApplication: "Pass Type Application",
  isInsuranceAllowed:"Is Insurance Allowed",
  allowPrebookOtp: "Allow Prebook Otp",
  allowDeliveryOtp: "Allow Delivery Otp",
  businessTypes: "Business Types",
  isVrnValidationRequired: "Is VRN Validation Required",
  showPmsEnteredVehicles:"Show Pms Entered Vehicle",
  paymentPicked: "Payment Picked",
  trnxNo: "Transaction No.",
  trnxDate: "Transaction Date",
  bankName: "Bank Name",
  trnxAmt:"Transaction Amount",
  document:"Document",
  challanDocument:"Challan Document",
  chequePickedView: "View Cheque Picked",
  pickedCheque: "Picked Cheque",
  dispatchConf: "Dispatch Confirmation",
  dispatchCheque: 'Are you sure to dispatch',
  dispatchSuccess: 'Dispatched Successfully.',
  chequeTrnxNo: 'Cheque/Transaction No.',
  chequeTrnxAmt: 'Cheque/Transaction Amount.',
  sitesGates: 'Gates',
  gateDescription : 'Gate Description',
  assetMapping : 'Asset Mapping',
  assets: 'Assets',
  make : 'Make',
  photo : 'Photo',
  scanBarCode : 'Scan Barcode',
  assetDetails : 'Child Details',
  assetSuccess : 'Asset Mapped Successfully',
  returnToListingPage : 'Return to list',
  assetMappingInfo : 'Asset Mapping Info',
  identifier : 'Identifier',
  assetMappedBy : 'Asset Mapped By',
  barcode : 'Bar Code',
  specification : 'Specification',
  siteAssetMapping : 'Asset Mapping',
  barcodeStatus: 'Barcode Status',
  parentMaterial: 'Parent Material',
  childMaterial: 'Child Material',
  assetMapingOld: 'Asset Mapping (Old)',
  rmName : 'RM Name',
  liveDate : 'Site Live Date',
  fission: 'LeadX',
  modifyvendorPaymentRequest: 'Modify Request',
  flow:'Flow',
  returnTag: 'Return Tag MRF',
  fromTag: 'From Tag',
  toTag: 'To Tag',
  clinetPoc : 'Client Poc',
  addressCreatedBy : 'Address Created By',
  clientGST : 'Client GST',
  clinetAddresses : 'Client Address',
  RequestDetails: "Request Details",
  userUploadedDocument:"User Uploaded Document",
  FinanceUploadedDocument:"Finance Uploaded Document",
  internalWallet:"Internal Wallet",
  externalWallet: "Partner Wallet",
  // first interaction form
  date : 'Date',
  firstInteractionForm : 'First Interaction Form',
  rwaFirForm : 'RWA FIR Form',
  meetingPersonName : 'Meeting Person Name',
  totalFlats : 'Total Flats',
  total4W2W : 'Total 4W & 2W',
  totalTagsOrdered : 'Total Tags Ordered',
  total4W2WTagsOrdered : 'Total 4W & 2W tags ordered',
  informationSignages : 'Information signages',
  brandedSignage : 'Branded signage (Directions & Traffic movement)',
  fitkitQty : 'FITKIT QTY',
  priceOfFitkit : 'Price of FITKIT',
  typeOfIntegration : 'Integration',
  integrationRemark : 'Integration Remark',
  tentativeLiveDate : 'Tentative Live Date',
  paymentBriefingRemark: 'Payment Briefing Remark',
  internetIsAvailable : 'Internet is available',
  occupiedSlots : 'Occupied slots',
  freeSlots : 'Free Slots',
  visitorsParkingSlots : 'Visitors parking slots',
  estimatedAllottedParkingSlotsPerFlat : 'Estimated allotted parking slots per flat',
  rentalPrice : 'Rental Price',
  capexPricePerGate : 'Capex price per gate',
  frequencyOfPayment : 'Frequency of payment (Monthly/Quarterly,etc)',
  haveYouChecked : 'Have you checked the agreement',
  noOfHelpdesk : 'No. of helpdesk/carnival',
  paymentTerms : 'Payment Terms',
  agreementSignedBy : 'Agreement signed by (Name)',
  amountGivenToPark : 'Amount given to Park+',
  detailsOfPayment : 'Details of payment (NEFT/Cheque/E-Nach)',
  dashboardTraining : 'Dashboard Training',
  howToRaiseComplaints : 'How to raise complaints',
  paymentBriefing : 'Payment Briefing',
  carnivalOverview : 'Carnival Overview',
  troubleshootingFAQ : 'Troubleshooting & FAQ',
  trainingFeedback : 'Training Feedback (Please share your feedback and further training requirement details)',
  tagActivation : 'Tag Activation',
  parkPartner : 'Park+ Partner',
  carDisplay : 'Car Display (Dealership)',
  dailyCarCleaningSubscription : 'Daily Car Cleaning Subscription',
  inauguration : 'Inauguration',
  chiefGuestName : 'Chief Guest Name',
  chiefGuestDesignation : 'Chief Guest Designation',
  reasonForNotOpting : '(Reason for not opting any activity)',
  carnivalDateTime : 'Carnival Date & Time',
  identifiedAreaAndLocation : 'Identified area and location (Ensure it is more than 15*50 feet in size)',
  flagInstallation : 'Flag installation',
  requiredProjectName: 'Project name is required!',
  requiredCityName : 'City name is required!',
  requiredMeetingPersonName : 'Meeting person name is required!',
  aligningRWA  : 'Aligning the RWA to ask Residents to come with cars during Carnival',
  pushMessage : 'Push message and in-app notification to residents prior to the carnival',
  confirmationPark : 'Confirmation for Park+ Associated Partners in Carnival(mandatory)',
  rmSignature : 'RM Signature',
  corporateMall : 'Corporate-Mall Form',
  noOfParticipants : 'No. of participants',
  noOf4W : 'Number of 4W',
  totalTenants : 'Total Tenants',
  noOf2W : 'Number of 2W',
  signages : 'Signages',
  infoOnSignageInstallation : 'Info on signage installation',
  accessManagementRFID4W : 'Access Management RFID (4W)',
  accessManagementRFID2W : 'Access Management RFID (2W)',
  accessInventoryMgmt4W : 'Access + Inventory Management RFID (4W)',
  accessInventoryMgmt2W : 'Access + Inventory Management RFID (2W)',
  accessInventoryMgmtVisitors : 'Access + Inventory Management RFID (Visitors)',
  fastagIntegration : 'Fastag Integration',
  fastagAccessCharging : 'Fastag access + Charging',
  subgatingFlow : 'Subgating Flow',
  parkRFIDTags4W : 'Park+ RFID Tags (4W)',
  parkRFIDTags2W : 'Park+ RFID Tags (2W)',
  parkHandheldTags2W : 'Park+ Handheld Tags (2W)',
  parkTags : 'Park+ Tags',
  fastags : 'Fastags',
  anprAccess : 'ANPR Access',
  anprLogging : 'ANPR Logging',
  camera : 'CAMERA',
  cameraIntegration : 'CAMERA Integration',
  tvmIntegration : 'TVM Integration',
  newTvm : 'New TVM',
  pgsBasic : 'PGS (Basic)',
  pgsUpgrade : 'PGS (Upgrade)',
  pgsFullversion : 'PGS (Full Version)',
  ledDisplayBoard : 'LED Display board (4r x 3C)',
  singleRowLed : 'Single row LED',
  twoRowLed : 'Two row LED',
  tvScreen : 'TV Screen',
  outdoorScreens : 'Outdoor Screens',
  posWithPms : 'POS (With PMS)',
  posCharging : 'POS Charging (with PMS)',
  posChargingCardPayment : 'POS Charging & Card Payment(with PMS)',
  posWithController : 'POS (with controller)',
  posSimBased : 'POS (SIM Based)',
  slotAvailability : 'Slot availability on Park+ App',
  anyOtherRequirements : 'Any other requirements (Pls Specify)',
  projectBoqAnnexue : 'Project BOQ annexure attached',
  layoutDiscussed : 'Layout Discussed and attached',
  brdDiscussed : 'BRD discussed and attached',
  flowchartUsecase : 'Flowchart/Use case attached',
  printSlipFormat : 'Print Slip format received',
  focReasonsRequired : 'FOC reasons required for POS',
  tenantSlotsParking : 'Tenants/Slots/Parking charging requisition format shared',
  tagOnboardingProcess : 'Tag Onboarding Process',
  internetAvailabiltyDate : 'Internet Availavility Date',
  ipWhitelisting : 'IP Whitelisting (In case of Firewall)',
  openPortsAvi : 'Open ports avi (In case of Firewall)',
  howToActivateTags : 'How to open tags',
  workPermitAllDays : 'Work Permit for all days',
  additionalPermitRequired : 'Is additional permit required to work on heights',
  storageAvailable : 'Is storage available on site',
  permitRequired : 'Is there a permit required for material in/out',
  specificWorkPermission : 'Any Specific work permission requirement',
  carHealthCheckup : 'Car Health Check Up',
  fastagHelpDesk : 'Fastag Help Desk',
  parkplusGo : 'Park+ Go',
  dailyCarCleaning : 'Daily Car Cleaning',
  parkplusRetailProducts : 'Park+ Retail Products',
  tagPaymentAssistance : 'Tag Payment Assistance',
  otherFacilities : 'Other Facilities',
  aligningBuildingAdmin : 'Aligning the building admin to ask tenants/employees to come with cars.',
  deliverychallanHardware : 'Delivery Challan of hardware material delivered at site',
  deliverychallanPower : 'Delivery Challan of power cables, earthing cables, LAN wires, building materail',
  handoversignDocument : 'Handover sign off document',
  warrantyCertificates : 'Warranty Certificate',
  workcompletionCertificate : 'Work Complete Certificate',
  trainingCertificate : 'Training Certificate',
  specificDocument : 'Any Specific document(Please Mention)',

  // Site Maintenance
  siteMaintenance : 'Contract M. List',
  siteVisitTask:'Site Visit',

  viewHelpers: 'View Helpers',
  addHelper: 'Add Helper',
  ediHelper: 'Edit Helper',
  HelperName: 'Helper Name',
  HelperDesignation: 'Helper Designation',
  HelperPhoneNumber: 'Helper Phone Number',
  helperDetailTitle: 'Enter helper Details',
  helperPocDetail: 'Edit helper Details',
  helperSuccess: 'Helper details successfully submitted.',
  helperFailed: 'Helper details Failed to submitted.',
  HelperList: 'View helper Listing',
  inactive: 'Inactive',
  handHeldTags : 'Hand Held Tags',
  ipWhitelisitngRemark : 'IP Whitelisting Remark',
  openportAvlRemark : 'Open Ports Avl Remark',
  workPermitRemark : 'Work Permit Remark',
  paymentcollectionmethod : 'Payment Collection Method',
  mdrValuefinalized : 'Is MDR Value finalized? Is Yes Please Mention',
  mdrvalueRemark : 'MDR Value Remark',
  agreementSignedBetween : 'Agreement Signed between both Park+ & Client to setup payment remittance process',
  tenantSlotsData: 'Tenant Slots Data Received',
  tenantlogin: 'Tenant Login Credentials Received',
  qrPlacement: 'QR Code Placement Plan',
  tenantAdmins: 'All Tenant Admins Meet Planned',
  standeeDeployment: 'Standee Deployment of Tabletop QR Code',
  firstReminder: 'First reminder communications',
  secondReminder: 'Second reminder communications',
  thirdReminder: 'Third reminder communications',
  fourthReminder: 'Fourth reminder communications',
  parkPartnerReason: "Park+ Partner Reason",
  dailyCarCleaningReason: "Daily Car Cleaning Reason",
  carDisplayReason: "Car Display Reason",
  flagInstallationReason: "Flag Installation Reason",
  aligningBuildingAdminReason: "Reason",
  siteActions: 'Approvals',
  siteDismantleLegalApproval: 'Site Dismantle / Legal Dispute Approval',
  registeredName: 'Registered Name',
  opportunity: "Opportunity",
  fillFirstInteraction: 'Fill First Interaction',
  passcode: 'Passcode',
  firSuccess: 'FIR Submit Successfully',
  assesment: "Assessment",
  assesmenResources: "Assessment Resources",
  training: "Training + Assessment",
  levels: "Levels",
  levelTest: "Level Test",
  level: "Level",
  history : "History",
  assesmentResult: "Assessment Result",
  requestList: "Request List",
  transactionList: "Transaction List",
  transactionRequest: "Request List",
  transactionRequestView: "Transaction Request View",
  partnerWallet: "Partner Wallet",
  approvalList: "Approval Listing",
  saleTypeHeading: 'Sale Type',
  typeOfSales: 'Type Of Sales',
  channelPartner: 'Channel Partner',
  channelPartnerName: 'Channel Partner Name',
  helpdesk: 'Finance Helpdesk',
  config: 'Configuration',
  configuration: 'Config',
  userName: 'User Name',
  firstApproval: 'First Approver Name',
  secondApproval: 'Second Approver Name',
  helpdeskConfigSuccess: 'Config Submitted Successfully',
  updateConfigSuccess: 'Config Submitted Successfully',
  useCase:'Use Cases',
  userRequest: 'User Request',
  piNo: 'PI No',
  piNoCommaSeparated: `PI's to be converted (Comma Separated)`,
  piTiEitherSingleRequired: 'Either PI No or TI No must be a single value when the other has multiple values.',
  piTiSingleOnly: 'Only a single value is allowed.',
  tiNo: 'TI No',
  tiNoCommaSeparated: `TI's to be cancelled (Comma Separated)`,
  fetchMrfNumbers: 'Fetch MRF Numbers',
  fetchingMrf: 'Fetching MRF Numbers...',
  mrfNumbers: 'MRF Numbers',
  tiNoRequiredForMrf: 'Please enter TI No(s) to fetch MRF Numbers.',
  noMrfFound: 'No MRF Numbers found for the provided invoice number(s).',
  fetchMrfBeforeSubmit: 'Please fetch MRF numbers before submitting.',
  mrfFetchHint: 'Enter TI number(s) above, then fetch the linked MRF numbers to continue.',
  mrfFoundCount: '{count} MRF number(s) found. Select one below.',
  reasonForConversion: 'Reason for conversion',
  attachmentProof: 'Attachment Proof',
  backToModification:' Send Back To Modification',
  pendingRequest:'Pending List',
  userRequestApprovedAndRejected: "Approved Or Rejected List",
  financeApprovePendingList: "Finance Approve Pending",
  requestId:"Request Id",
  requestName:'Request Name',
  markAsClosed: 'Mark as closed',
  rca: 'RCA',
  message: 'Message',
  dealerWallet: 'Dealer Wallet',
  searchDealer: 'Add Request',
  dealerDeatails: 'Dealer Details',
  walletApprovalDealer: 'Dealer Approval',
  walletDealerApproval: 'Dealer Wallet Approval',
  addAttachment: 'Attachment',
  project: 'Business & Client',
  selectPmEngineer: 'Select PM Engineer',
  PmSoftwareMaintenanceSites:"Pm Software Sites",
  invoiceNumber: 'Invoice Number',
  ToolkitAlert: "Toolkit Missing Alert",
  rejectionReason:"Finance Rejection Reason :",
  ticketTags: 'Ticket Tag',
  nameOfSpoc: 'Name of SPOC',
  numberOfPoc: 'Number of POC',
  ledgerList: 'Ledger List',
  downloadLedger: 'Download',
  InvoiceValidation:"Invoice Validation Ticket",
  posShipment: 'POS Shipment',
  pos: 'POS',
  revenueNature:"Revenue Nature",
  revenueType:"Revenue Type",
  revenueInvoiceType:"Invoice Type",
  Revenue:'Revenue Details',
  requiredRevenueType: 'Revenue Type is required!',
  requiredRevenueNature: 'Revenue Nature is required!',
  requiredRevenueInvoice: 'Revenue Invoice Type is required!',
  amountRequired:"Amount Required",
  menDays:"Men Days",
  unitPricePerDayPerPerson:'Price Per Day/Per Person',
  menDaysRequired: 'Men Days is Required.',
  documentUpload: 'Upload Documents',
  uploadClientBrd: 'Upload Client BRD',
  clientBrd: 'Client BRD',
  pleaseUploadBrd: 'please upload brd document',
  tutorial: "Tutorial",
  question: "Question",
  answer: "Answer",
  pdfUpload: "Upload PDF",
  videoUpload: "Upload Video",
  imageUpload: "Upload Image",
  questionType: "Resource Type",
  tutorialQuestion: "Tutorial Question",
  pleaseUploadAttachment: "Please upload attchment",
  productService: 'Product/Services',
  typeOfEVCharges:"Type of Ev charges",
  brand:"Brand",
  variableServices:" Variable Services",
  fixedServices:" Fixed Services",
  serviceStartDay:"service day start",
  serviceStartDayRequired:"service day start is required",
  serviceEndDay:"service day End",
  serviceEndDayRequired:"service day End required",
  tutorialListing: "Questions List",
  addQuestion: "Add Question",
  reponsiblePersonMail: "Assigned Person Email",
  viewGoLiveChecklist: 'View Go Live Checklist',
  goLiveChecklist: 'Valet Go Live Checklist',
  VariableValetInvoice:"Variable Valet Invoice",
  FixedValetInvoice:"Fixed Valet Invoice",
  valetServicesLineItems: "Valet Service Line Items",
  reponsiblePersonMail: "Assigned Person Email",
  planSchedule: "Plan Schedule",
  uploadCSV: "Upload File (CSV)",
  planScheduleList: "Plan Schedule List",
  softwareRM: "Software RM",
  hardwareRM: "Hardware RM",
  approverL1: "Approver L1",
  approverL2: "Approver L2",
  uploadResponseList: "Response List",
  planScheduleUpload: "Plan Schedule Upload",
  createPR: 'Create PR',
  maintenanceSites: 'Maintenance Site',
  servicePr: 'Service PR',
  servicePrList: 'Service PR List',
  prApproval: 'PR Approval',
  prConfirmation: 'PR Confirmation',
  requestedQty: 'Requested Quantity',
  actualQty: 'Actual Quantity',
  prApproved: 'PR Approved Successfully.',
  rejectPR: 'Are you sure to reject this PR',
  returnToPrList: 'Return To PR Listing',
  fillMrfFirst: 'MRF not created',
  prdetails: 'Purchase Requisition Details',
  deliveryAddress: 'Delivery Address',
  vendorAddress: 'Purchase Requisition Address (Vendor)',
  prBillingAddress: 'Purchase Requisition Address (Bill to be sent at)',
  history: 'History',
  materialAndService: 'Material/Service',
  addOne: 'Purchase Requisition Address (Billing)',
  addTwo: 'Purchase Requisition Address (Delivery)',
  addThree: 'Purchase Requisition Address (Vendor)',
  addFour: 'Purchase Requisition Address (Bill to be sent at)',
  additionalServicePr: 'Additional Service PR',
  POSReplacement: 'POS Replacement',
  POSReturn: 'POS Return',
  replaceItems: 'Submit',
  parkingSites: 'POS Sites',
  hierarchyList: 'Request Helpdesk Fusion',
  valetIncentive: 'Valet Incentive Portal',
  edit: 'Edit',
  valetListing: 'Valet Listing',
  dataApproved: 'Data Approved Successfully',
  lastFiveTransactionsList: 'Last Five Transactions Listing',
  incentiveApproval: 'Incentive Approval',
  siteLeadReferral: 'Site Lead Referral',
  clientClientReferral: 'Client Client Referral',
  valetReferralTrackingDashboard: 'Valet Referral Tracking',
  valetReferral: 'Valet Referral',
  deviceDelink: 'Device Delink',
  internalCommunication: 'Internal Communication',
  notificationBroadcastCentre: 'Notification Broadcast Centre',
  saveDraft: 'Save as draft',
  completeDraft: 'Complete Draft',
  removeDraft: 'Discard Draft',
  dataSavedAsDraft: 'Data saved as draft',
  draftDiscarded: 'Draft discarded successfully',
  checkIn: 'Check-In',
  checkinDetails: 'Check-In Details',
  completeMeeting: 'Complete Meeting',
  checkInSucess: 'Check-In Successfully',
  otherSites: 'Other Sites',
  meetingType: 'Meeting Type',
  checkoutDetails: 'Check-out Details',
  pocRemark: 'POC Remark',
  active: 'Active',
  tagAmount: 'Tag Amount',
  advancePick: 'Advance Pick',
  advPaymentDate: 'Advance Payment Date',
  paymentRemark: 'Payment Remark',
  dashboardTraining: 'Dashboard Training',
  carnivalConduct: 'Carnival',
  dashboardTrainingChecklist: 'Checklist Form',
  scheduledActivity: 'Scheduled Activity',
  changeSlot: 'Change Slot',
  goToList: 'Go to list',
  refundRequest: 'Refund Requests',
  CxRefundApproval: "CX Refund Approval",
  posStock: "EMP-POS Mapping",
  posStockMapping: "Employee POS Mapping",
  adsSalesCampaign: "Ad Sales Campaigns",
  campaignCreation: "Campaign Creation",
  invoiceRequest: "Invoice Request",
  campaignList: "Campaign List",
  financeList: 'Finance List',
  addCampaign: 'Add Campaign',
  campaignList: 'Campaign List',
  createCampaign: 'Create Campaign',
  adsCampaign: 'Ads Campaigns',
  campaignType: 'Campaign Type',
  campaignSubtype: 'Campaign Sub-type',
  userSegment: 'User Segment',
  estRevenue: 'Est. Revenue',
  poMouDeal: 'PO/MoU of the deal',
  pocDetails: 'POC Details',
  pocName: 'POC Name',
  pocMobileNumber: 'POC Mobile Number',
  pocEmail: 'POC Email',
  managerPendingList: 'Manager Pending List',
  pidNumber: 'PID',
  pidName: 'PID Name',
  vendorName: 'Vendor Name',
  carnivalDate: 'Carnival Date',
  userRemark: 'User Remark',
  online: 'Online',
  offline: 'Offline',
  revenueImpression: 'Revenue Per Impression',
  revenueInstall: 'Revenue Per App Install',
  revenueCtr: 'Revenue Per CTR',
  revenueLeadConversion: 'Revenue Per Lead Conversions',
  revenueLeadBased: 'Revenue Per Lead',
  l2PendingList: 'L2 Pending List',
  createdEmail: 'Created Email',
  campaignDetailView: 'Campaign Detail View',
  detailView: 'Detail View',
  holidayView: 'Holiday View',
  monthlyValetSalary: 'Monthly Valet Salary',
  dailySalaryDistribution: 'Daily Salary Distribution',
  salaryMaster: 'Salary Master',
  dutyMode: 'Duty Mode',
  valetChat: 'Valet Chat List',
  raiseTicket: 'Raise Ticket',
  leveloneDetails: 'Level One Details',
  rcTransferList: 'RC Transfer List',
  addContractForBusiness: 'Add Contract For Business : ',
  nonOnboardBusinessApproval:'Business Approval',
  businessDetailsLabel: "Business Details",
  installationMrf: 'Installation Line Items',
  duplicateTicket:'Duplicate Ticket',
  mrfView: 'Mrf View',
  lastPmDate: 'Last PM Date',
  lastPmAssignedTo:'Last PM Assigned to',
  amcType: 'AMC Type',
  contractLiveFromDate:  'Contract Live From Date',
  contractLiveToDate:  'Contract Live To Date',
  contractExpiryFromDate:  'Contract Expiry From Date',
  contractExpiryToDate:  'Contract Expiry To Date',
  imageCompression:'Image Compression',
  issueRelatedTo: 'Issue Related To',
  rating: 'Rating',
  userRating: 'User Rating',
  meetingRating: 'Meeting Rating', 
  selfScorecard: 'Self Scorecard',
  hodScorecard: 'HOD Scorecard',
  seniorScorecard: 'Senior Scorecard',
  builderRwa:'Builder/RWA',
  builderRwaError:'Builder Type is required',
  ncsMeetings: 'NCS Meetings',
  completeCSmeeting: 'Complete NCS Meeting',
  completeMeetingNCS: 'NCS Meeting Schedule',
  fillDetails: 'Fill NCS Details',
  lastActivityDate:'Last Activity Date',
  boomBarierPresent:'Boom Barrier Present',
  competitorName:'Competitor Name',
  competitorSolution:'Competitor Solution',
  takeSelfie:'Take Selfie',
  existingProblemFaced:'Existing Problem Faced',
  accountName:'Account Name',
  accountAddress:'Account Address',
  checkboxDescriptoion: 'Not allowed to take information on the site',
  ncsMeetingDetails: 'Meeting Details',
  ncsScheduledAgainstSite: 'NCS Scheduled Against Site',
  ncsMeetingDetailsView: 'NCS Meeting Details',
  checkinAndCheckoutDetails: 'Checkin/Checkout',
  enterOTP: 'Enter OTP',
  eventDetails:"Event Details",
  eventStatus:"Event Status",
  requiredEventStatus:"Event Status is required",
  searchByVehicleNumber: 'Search By Vehicle No',
  searchByVehicleNumbers: 'Search By Vehicle Number',
  eventSalary:'Event Salary',
  mailPocDetails:'Mail POC Details',
  channelPartnerName:'Channel Partner Name',
  callToHotNegotiationSites: 'Call to Hot/Negotiation Sites',
  fillSitesForCallingForm: 'Fill the sites for calling form against the site for which call went',
  referralSharedViaWA: 'Referral Shared via WA',
  uploadReferralAttachment: 'Upload Referral Attachment',
  videoTestimonialFromClient: 'Video testimonial from the client?',
  shareWithManager: 'Share it with your manager to upload in the drive',
  wiringScope: 'Wiring',
  pricePerUnitMeter: 'Unit price per meter',
  itemPricePerQty: 'Item price per qty',
  totalPriceItem: 'Item total price',
  challanTitle: 'Challan Details',
  iMRFDetails: 'Installation MRF Details',
  mrfTagDetails: 'Tag MRF Details',
  challanDetails: 'Challan Line Item Details',
  salesOrderNumber: 'Sales Order Number',
  orderType: 'Order Type',
  shipmentDateTime: 'Shipment Date',
  uom: 'UOM',
  requiredQty: 'Required Quantity',
  clientBusinessName: 'Business Name',
  wiringScopePark: 'Wiring Scope',
  performanceTracker: 'Performance Tracker',
  executivesPerformanceTracker: 'Executives Performance Tracker',
  executivesTrackRecord: 'Executives Track Record',
  multiSelect:'Multi-Approve',
  consumables: 'Consumables',
  consumableItems: 'Consumable Items',
  reqSales: 'Required Quantity (Sales)',
  reqOps: 'Required Quantity (Operation)',
  itemUpdateSuccess: 'Items updated successfully',
  vendorAdvancePaymentRequest: 'Vendor Advance Payment Request',
  vendorPaymentDetails:'Vendor Request Details',
  takeAction:'Claim Invoice',
  takeAdvanceAction:'Claim Advance',
  paymentInvoiceRequestList:'Vendor Dashboard Request',
  shipments: 'Shipment',
  baseUnitPrice: 'Base Unit Price',
  salesOrderReturn: 'Sales Order Return',
  salesOrderReturnMrf: 'Sales Order Return MRF',
  outwardMrfNumber: 'Outward MRF Number',
  returnQuantity: 'Return Quantity',
  salesReturnSendToErp: 'Sales return sent to erp successfully',
  shipmentListing: 'Shipments',
  previewInvoice: 'Preview Invoice',
  disbursalEndDate: 'Disbursal End Date',
  disbursalStartDate: 'Disbursal Start Date',
  loggedInStartDate: 'Logged In Start Date',
  loggedInEndDate: 'Logged In End Date',
  isPanNumberReq: "Do you have a PAN Number?",
  errorPanReq: "Make at least one selection!",
  requiredPan: "Enter PAN Number to add client",
  checkPan: "Check PAN",
  competitionMapping: 'Competition Mapping',
  addNewSite: 'Add New Site',
  barrierInstalled: 'Barriers Installed',
  barrierBrand: 'Barrier Brand',
  otherBrandName: 'Other Brand Name',
  guardRemarks: 'Guard Remarks',
  siteAddedSuccessfully: 'Site Added Successfully',
  siteWithIn500Meter: 'Sites close to your current location',
  tanNumber: 'TAN Number',
  confirmTanNumber: 'Confirm TAN Number',
  tanAttachment: 'Upload TAN Proof',
  abscondDriverList: 'Abscond Driver List',
  abscondDrivers: 'Abscond Drivers',
  abscondPermanently: 'Abscond Permanently',
  releaseSalary: 'Release Salary',
  businessCredits: 'Business Credits',
  employeeCredits: 'Employee Credits',
  offroleEmployee: 'Offrole Employees',
  employeesApprovalList: 'Pending Approval',
  employeesOffboardOnboard: 'Onboarded Employees',
  fullName: 'Full Name',
  fathersName:  `Father's Name`,
  dateOfBirth: 'Date Of Birth',
  emergencyContactName: 'Emergency Contact Name',
  emergencyContactNumber: 'Emergency Contact Number',
  panImage: 'PAN Image',
  aadharImage: 'Aadhar Image',
  aadharNumber: 'Aadhar Number',
  aadharStatus: 'Aadhar Status',
  employeeDetails: 'Employee Details',
  roles: 'Role/Designation',
  employeeType: 'Employee Type',
  dateOfJoining: 'Date Of Joining',
  reasonForRejection: 'Rejection Reason',
  requestStatus: 'Request Status',
  employeeStatus: 'Employee Status',
  generateLink: 'Generate Link',
  generateOnboarding: 'Generate link for off-role employees',
  employeeMobileNumber: 'Employee Mobile Number (linked with aadhar)',
  vendor: 'Vendor',
  role: 'Role',
  dateOfExit: 'Date of exit',
  exitReason: 'Reason for exit',
  requestFromDate: 'Request From Date',
  requestToDate: 'Request To Date',
  approvedFromDate: 'Approved From Date',
  approvedToDate: 'Approved To Date',
  lastWorkingDate: 'Last Working Date',
  attendanceType: 'Attendance Type',
  confirmBusinessName: 'Confirm Business Name',
  nomeneclatureHardware: 'Invoice Specification',
  nomeneclatureInstalltion: 'Invoice Specification',
  nomeneclatureTags: 'Invoice Specification',
  nomeneclatureCartage: 'Invoice Specification',
  nomeneclatureLabour: 'Invoice Specification',
  capex_pi_placeholder: 'Do you need an advance PI?',
  capex_pi_placeholer2: '(Solution level nomenclature)',
  capex_pi_amount_placeholder: 'X% of contract amount?',
  mileston_advance: 'Advance %',
  milestone_material_delivery: 'Material Delivery %',
  milestone_hardware: 'Hardware Installation %',
  milestone_handover: 'Handover Testing %',
  capex_convert_pi_ti: 'Convert Advance PI to TI?',
  capex_convert_pi_ti_placeholder2: 'If NO, advance will be included\nin the next defined milestone',
  capex_milestone_amount_placeholder: 'X amount of contract?',
  consumables: 'Consumables Item',
  finalBilling: 'Final Billing',
  capexDetails: 'Capex Details',
  convertToTI: 'Convert to TI',
  requestCancellation: 'Request Cancellation',
  withdrawRequest: 'Withdraw',
  rejectRequest: 'Reject Request',
  cancelTiConversion: 'Cancel TI Conversion',
  contractAmount: 'Contract',
  hardwareAmount: 'Hardware',
  tagsAmount: 'Tags',
  capexIntstallationAmount: 'Installation',
  cartage: 'Cartage',
  invoiceFrequency: 'Invoicing Frequency',
  hardwareFrequency: 'Hardware/Tags Invoice Nomenclature',
  consumbaleFrequency: 'Consumables Nomenclature',
  raBills: 'will invoices be as per RA Bills ?',
  milestoneNo: 'Milestone',
  addShippingAddress: 'Add Shipping Address',
  advanceSalary: 'Advance Salary',
  approveVendor: 'Approve Vendor',
  rejectVendor: 'Reject Vendor',
  vendorPendingApprovalRequests: 'Approval Pending Requests',
  softwareInventory: 'Software Inventory',
  insightsCategory: 'Insights Category',
  InsightsSubCategory: 'Insights Sub-Category',
  MrfTypes: 'MRF Types',
  submittedSuccessfully: 'Submitted Successfully',
  downloadSampleCSV: 'Download Sample CSV',
  jmsApprovals: 'JMS Approvals',
  prApprovals: 'PR Approvals',
};

export default English;
